﻿(() => {
  'use strict';

  const DRAWER_ID = 'AiCheckoutCrystal';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const DEFAULT_CONFIG = {
    checkoutMode: 'inline_payment', layoutStyle: 'boxed', scale: 100, inactiveDeliveryOpacity: 40,
    emphasizeSelectedDelivery: true, deliverySearchLayout: 'under_selected', cartHeading: 'Искам да поръчам:', detailsHeading: 'Чудесно.',
    detailsText: 'Моля, въведете данните си за доставка.', deliveryHeading: '', deliveryText: '', paymentHeading: 'Как желаете да платите?',
    paymentText: 'Изберете удобния за Вас начин на плащане.', checkoutCta: 'Премини към плащане', paymentOptionsDisplay: 'immediate',
    showCompareAt: true, showSavings: true, showDiscountCodeField: true, showActiveDiscounts: true, autoScrollPayment: true, autoHeightPayment: true,
    hideExpressCheckout: true, hideContact: true, hideDelivery: true, hideRememberMe: true,
    hideBilling: true, hideOrderSummary: true, hidePaymentIntro: true,
    useUpsell: false, upsellDiscountPercent: 20, upsellDiscountCode: '', upsellProduct: null,
    upsellItems: [], upsellLayout: 'list', upsellListUseCheckboxes: true, upsellPreselectAll: false, upsellProductLinks: true, upsellBadge: 'Специална оферта',
    upsellHeading: 'Добавете още продукт към поръчката си', upsellIntro: 'Изберете специално предложение само за тази поръчка.',
    upsellDiscountCopy: 'Само сега получавате {discount}% намаление.', upsellSavingsCopy: 'Спестявате {amount}',
    upsellAddCopy: 'Добави', upsellSkipCopy: 'Не, благодаря'
  };
  function readBuilderConfig(scope = document) {
    const node = scope.querySelector?.('[data-aic-config]') || document.querySelector('[data-aic-config]');
    if (!node) return { ...DEFAULT_CONFIG };
    try {
      const parsed = JSON.parse(node.textContent || '{}');
      if (parsed && parsed.base && Array.isArray(parsed.profiles)) {
        const activeSlot = parsed.activeProfile || 'base';
        const profile = activeSlot === 'base' ? null : parsed.profiles.find((entry) => entry?.slot === activeSlot);
        const activeSettings = profile?.settings || parsed.base || {};
        return {
          ...DEFAULT_CONFIG,
          ...(parsed.shared || {}),
          ...activeSettings,
          __profile: {
            slot: profile?.slot || 'base',
            name: profile?.name || 'Base / Current settings',
            id: profile?.id || null,
            requestedSlot: activeSlot,
            fallbackToBase: activeSlot !== 'base' && !profile,
          },
        };
      }
      return { ...DEFAULT_CONFIG, ...parsed };
    } catch (_) {
      return { ...DEFAULT_CONFIG };
    }
  }
  // Only the contextual demo uses the full Shopify checkout page.
  // Ordinary Crystal Energy visits keep their configured checkout behaviour.
  function demoCheckoutConfig(config) {
    const demoPage = /\/pages\/easy-checkout-demo\/?$/.test(window.location.pathname);
    const demoEntry = ['black-tourmaline', 'citrine'].includes(new URLSearchParams(window.location.search).get('easy_checkout_demo'));
    if (window.Shopify?.designMode || (!demoPage && !demoEntry)) return config;
    return { ...config, checkoutMode: 'normal', paymentOptionsDisplay: 'after_button', checkoutCta: 'Продължи към Shopify checkout' };
  }
  let CONFIG = demoCheckoutConfig(readBuilderConfig());
  let cart = null;
  const productVariantPriceCache = new Map();
  let busy = false;
  let discountBusy = false;
  let discountInputDraft = '';
  let discountFeedback = null;
  let lastTrigger = null;
  let step = 'cart';
  let upsellDecision = null;
  const upsellAddedKeys = new Set();
  const upsellSelectedKeys = new Set();
  let upsellSelectionInitialized = false;
  let upsellInitialCartProductIds = new Set();
  let upsellInitialCartVariantIds = new Set();
  let shouldPinDetailsStart = false;
  let customerDraft = { firstName: '', lastName: '', phone: '', email: '' };
  let shippingSelection = null;
  let shippingMethod = 'OFFICE';
  let shippingOption = null;
  let shippingRates = [];
  let shippingSearchTimer = null;
  const shippingSearchDrafts = new Map();
  let shippingAddressDraft = { city: '', zip: '', address1: '', cityRecord: null };
  let shippingSearchSeq = 0;
  let shippingSearchResults = [];
  let shippingCityResults = [];
  let shippingAddressStatus = { state: 'idle', message: '' };
  let shippingAddressTimer = null;
  let shippingAddressSeq = 0;
  let shippingEditing = true;
  let shippingCartWrite = Promise.resolve();

  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'bg-BG', {
    style: 'currency', currency: currency || 'EUR'
  }).format((Number(cents) || 0) / 100);

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[char]));

  async function cartRequest(path = '.js', init) {
    const response = await fetch(`${ROOT}cart${path}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(init?.headers || {}) },
      ...init
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || 'Не успяхме да обновим количката.');
    return payload;
  }

  function suppressNativeDrawer() {
    document.querySelector('.js-mini-cart')?.classList.remove('active');
    document.documentElement.classList.remove('cart-open');
    document.body.classList.remove('cart-open');
  }

  function syncThemeCount() {
    if (!cart) return;
    document.querySelectorAll('.js-cart-count').forEach((node) => {
      const parent = node.closest('.site-header__cart');
      node.textContent = parent ? `(${cart.item_count})` : String(cart.item_count);
    });
  }

  function openAiMeasurementAllowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.marketingAllowed?.() === true && privacy?.analyticsProcessingAllowed?.() === true;
    } catch (_) { return false; }
  }

  async function openAiUpdateKnownUser() {
    if (!openAiMeasurementAllowed() || typeof window.oaiq !== 'function' || !window.crypto?.subtle) return;
    const email = String(customerDraft.email || '').trim().toLowerCase();
    const phone = String(customerDraft.phone || '').trim().replace(/[\s().-]/g, '').replace(/^\+/, '').replace(/^0+/, '');
    const normalizeName = (value) => String(value || '').toLowerCase().replace(/[\s\x21-\x2f\x3a-\x40\x5b-\x60\x7b-\x7e]/g, '');
    const values = {
      email_sha256: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '',
      phone_number_sha256: /^\d{8,15}$/.test(phone) ? phone : '',
      first_name_sha256: normalizeName(customerDraft.firstName),
      last_name_sha256: normalizeName(customerDraft.lastName)
    };
    // Never enrich an anonymous visit with guessed or incomplete contact data.
    if (!values.email_sha256 && !values.phone_number_sha256) return;
    const user = {};
    await Promise.all(Object.entries(values).map(async ([key, value]) => {
      if (!value) return;
      const hash = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
      user[key] = Array.from(new Uint8Array(hash), (byte) => byte.toString(16).padStart(2, '0')).join('');
    }));
    if (shippingMethod === 'ADDRESS') {
      if (shippingAddressDraft.city) user.city = String(shippingAddressDraft.city).trim().slice(0, 128);
      if (shippingAddressDraft.zip) user.postal_code = String(shippingAddressDraft.zip).trim();
    }
    if (openAiMeasurementAllowed()) window.oaiq('init', { user });
  }

  async function openAiMeasure(eventName, eventData, options) {
    try {
      if (typeof window.oaiq !== 'function' || !openAiMeasurementAllowed()) return;
      // Enrichment must not prevent a valid event if hashing is unavailable.
      await openAiUpdateKnownUser().catch(() => undefined);
      if (!openAiMeasurementAllowed()) return;
      window.oaiq('measure', eventName, eventData, options);
    } catch (_) {}
  }

  function openAiCurrency() {
    const currency = String(window.Shopify?.currency?.active || cart?.currency || '').trim().toUpperCase();
    return /^[A-Z]{3}$/.test(currency) ? currency : '';
  }

  function openAiAddedItems(payload) {
    return Array.isArray(payload) ? payload : Array.isArray(payload?.items) ? payload.items : payload ? [payload] : [];
  }

  function openAiRequestedItems(formData) {
    const indexed = new Map();
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (!match) continue;
      if (!indexed.has(match[1])) indexed.set(match[1], {});
      indexed.get(match[1])[match[2]] = value;
    }
    return indexed.size ? Array.from(indexed.values()) : [{ id: formData.get('id'), quantity: formData.get('quantity') || 1 }];
  }

  function openAiItemsForAdd(payload, requested) {
    // Shopify returns the resulting line quantity, not the quantity just added.
    const remaining = new Map();
    requested.forEach((item) => {
      const id = String(item.id || '');
      remaining.set(id, (remaining.get(id) || 0) + Math.max(0, Math.round(Number(item.quantity ?? 1) || 0)));
    });
    return openAiAddedItems(payload).map((item) => {
      const id = String(item.variant_id || item.id || '');
      const quantity = Math.min(remaining.get(id) || 0, Math.max(0, Number(item.quantity) || 0));
      remaining.set(id, Math.max(0, (remaining.get(id) || 0) - quantity));
      return { ...item, quantity };
    }).filter((item) => item.quantity > 0);
  }

  function openAiContentsFromItems(items) {
    const currency = openAiCurrency();
    return openAiAddedItems(items).map((item) => {
      const id = item?.variant_id || item?.variantId || item?.id;
      const quantity = Math.max(1, Math.round(Number(item?.quantity) || 1));
      const content = { content_type: 'product', quantity };
      const name = item?.product_title || item?.title || item?.name;
      const rawAmount = item?.final_price ?? item?.price;
      const amount = rawAmount == null ? NaN : Number(rawAmount);
      if (id != null) content.id = String(id);
      if (name) content.name = String(name);
      if (currency && Number.isFinite(amount) && amount >= 0) {
        content.amount = Math.round(amount);
        content.currency = currency;
      }
      return content;
    }).filter((content) => content.id || content.name);
  }

  function measureOpenAiItemsAdded(items) {
    const contents = openAiContentsFromItems(items);
    if (!contents.length) return;
    return openAiMeasure('items_added', { type: 'contents', contents });
  }

  function measureOpenAiUpsellItemAdded(items) {
    const contents = openAiContentsFromItems(items);
    if (!contents.length) return;
    return openAiMeasure('custom', { type: 'custom', contents }, { custom_event_name: 'upsell_item_added' });
  }

  function measureOpenAiCheckoutStarted() {
    const eventData = {
      type: 'contents',
      contents: openAiContentsFromItems(cart?.items || [])
    };
    const amount = Number(cart?.total_price);
    const currency = openAiCurrency();
    if (cart?.total_price != null && currency && Number.isFinite(amount) && amount >= 0) {
      eventData.amount = Math.round(amount);
      eventData.currency = currency;
    }
    return openAiMeasure('checkout_started', eventData);
  }

  function applyBuilderPresentation() {
    const root = document.getElementById(DRAWER_ID);
    if (!root) return;
    root.dataset.aicLayout = CONFIG.layoutStyle === 'flat' ? 'flat' : 'boxed';
    root.dataset.aicMode = CONFIG.checkoutMode || 'inline_payment';
    const scale = Math.max(90, Math.min(120, Number(CONFIG.scale) || 100));
    const inactiveOpacity = Math.max(25, Math.min(100, Number(CONFIG.inactiveDeliveryOpacity) || 40)) / 100;
    root.style.setProperty('--aic-ui-scale', String(scale / 100));
    root.style.setProperty('--aic-inactive-delivery-opacity', String(inactiveOpacity));
  }

  function scrollAicThreadTo(selector, { behavior = 'smooth', offset = 12 } = {}) {
    const thread = document.querySelector('[data-aic-thread]');
    const target = document.querySelector(selector);
    if (!thread || !target || !target.isConnected) return false;
    const threadRect = thread.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const top = Math.max(0, thread.scrollTop + targetRect.top - threadRect.top - offset);
    thread.scrollTo({ top, behavior });
    return true;
  }

  function queueAicThreadScroll(selector, options = {}) {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      scrollAicThreadTo(selector, options);
    }));
  }

  function queueDetailsStartScroll() {
    const thread = document.querySelector('[data-aic-thread]');
    if (!thread) return;
    thread.style.setProperty('overflow-anchor', 'none');
    thread.style.setProperty('scroll-behavior', 'auto', 'important');
    const pin = () => {
      if (step === 'details') scrollAicThreadTo('[data-aic-details-start]', { behavior: 'auto', offset: 12 });
    };
    pin();
    requestAnimationFrame(() => requestAnimationFrame(pin));
    setTimeout(pin, 120);
    setTimeout(() => {
      pin();
      thread.style.removeProperty('overflow-anchor');
      thread.style.removeProperty('scroll-behavior');
    }, 420);
  }

  function ensureShell() {
    if (document.getElementById(DRAWER_ID)) { applyBuilderPresentation(); return; }
    const root = document.createElement('div');
    root.id = DRAWER_ID;
    root.dataset.aicFallbackRoot = 'true';
    root.innerHTML = `
      <div class="aic-backdrop" data-aic-backdrop></div>
      <aside class="aic-drawer" data-aic-drawer role="dialog" aria-modal="true" aria-hidden="true" aria-label="AI Checkout">
        <header class="aic-header">
          <div class="aic-brand">Вашата Количка</div>
          <button class="aic-close" type="button" data-aic-close aria-label="Затвори">×</button>
        </header>
        <div class="aic-thread" data-aic-thread aria-live="polite"></div>
      </aside>`;
    document.body.appendChild(root);
    applyBuilderPresentation();
  }

  function snapshotCartBeforeUpsell() {
    upsellInitialCartProductIds = new Set();
    upsellInitialCartVariantIds = new Set();
    (cart?.items || []).forEach((item) => {
      const productId = Number(item.product_id || 0);
      const variantId = Number(item.variant_id || item.id || 0);
      if (productId > 0) upsellInitialCartProductIds.add(productId);
      if (variantId > 0) upsellInitialCartVariantIds.add(variantId);
    });
  }

  function normalizeUpsellProduct(entry, index) {
    const raw = entry?.product || entry;
    if (!raw) return null;
    const variantId = Number(raw.variantId || 0);
    const price = Number(raw.price || 0);
    const key = String(entry?.blockId || raw.id || variantId || index);
    const percentage = Math.max(1, Math.min(90, Math.round(Number(entry?.discountPercent ?? CONFIG.upsellDiscountPercent) || 20)));
    if (!variantId || price <= 0 || raw.available === false || raw.variantAvailable === false) return null;
    const productId = Number(raw.id || 0);
    const matchingCartItem = (cart?.items || []).find((item) => {
      const itemProductId = Number(item.product_id || 0);
      const itemVariantId = Number(item.variant_id || item.id || 0);
      return (productId > 0 && itemProductId === productId) || itemVariantId === variantId;
    });
    const alreadyInCart = !!matchingCartItem;
    const wasInCartBeforeUpsell = (
      (productId > 0 && upsellInitialCartProductIds.has(productId))
      || upsellInitialCartVariantIds.has(variantId)
    );
    const itemProperties = matchingCartItem?.properties || {};
    const isUpsellLine = String(itemProperties.__aic_upsell || '').toLowerCase() === 'true';
    const lineUpsellKey = String(itemProperties.__aic_upsell_key || '');
    const addedInCurrentUpsell = alreadyInCart
      && !wasInCartBeforeUpsell
      && (upsellAddedKeys.has(key) || (isUpsellLine && (!lineUpsellKey || lineUpsellKey === key)));
    if (alreadyInCart && !addedInCurrentUpsell) return null;
    // Before adding, only the catalog price is known; a configured percentage
    // is not proof that Shopify will accept a discount for this cart.
    const discountedPrice = matchingCartItem ? getCartItemUnitPrice(matchingCartItem) : price;
    return {
      ...raw,
      key,
      variantId,
      price,
      percentage,
      discountCode: String(entry?.discountCode ?? CONFIG.upsellDiscountCode ?? '').trim(),
      discountedPrice,
      savings: price - discountedPrice,
      title: raw.title || 'Специална оферта',
      image: raw.image || '',
      added: addedInCurrentUpsell
    };
  }

  function getUpsellProducts() {
    if (!CONFIG.useUpsell) return [];
    const blockItems = Array.isArray(CONFIG.upsellItems) ? CONFIG.upsellItems : [];
    const sourceEntries = blockItems.length
      ? blockItems
      : (CONFIG.upsellProduct ? [{
          blockId: 'legacy',
          sourceType: 'product',
          product: CONFIG.upsellProduct,
          discountPercent: CONFIG.upsellDiscountPercent,
          discountCode: CONFIG.upsellDiscountCode,
        }] : []);
    const source = sourceEntries.flatMap((entry, entryIndex) => {
      const sourceType = String(entry?.sourceType || 'product').toLowerCase();
      if (sourceType !== 'collection') return [entry];
      const products = Array.isArray(entry?.products) ? entry.products : [];
      return products.map((product, productIndex) => ({
        ...entry,
        blockId: `${entry?.blockId || `collection-${entryIndex}`}:${product?.id || product?.variantId || productIndex}`,
        product,
      }));
    });
    const seenProducts = new Set();
    return source.map(normalizeUpsellProduct).filter((upsell) => {
      if (!upsell) return false;
      const identity = String(upsell.id || upsell.variantId);
      if (seenProducts.has(identity)) return false;
      seenProducts.add(identity);
      return true;
    }).slice(0, 10);
  }

  function getUpsellProduct(key = '') {
    const products = getUpsellProducts();
    if (!key) return products[0] || null;
    return products.find((upsell) => upsell.key === String(key)) || null;
  }

  function getUpsellDiscountCode(upsell) {
    return String(upsell?.discountCode || '').trim();
  }

  async function applyUpsellDiscountCode(upsell) {
    const code = getUpsellDiscountCode(upsell);
    if (!code) return true;
    const existing = activeManualDiscountCodes();
    if (existing.some((entry) => entry.toLowerCase() === code.toLowerCase())) return true;
    await updateCartDiscountCodes([...existing, code], code);
    return (cart?.discount_codes || []).some((entry) => (
      String(entry?.code || '').toLowerCase() === code.toLowerCase() && entry?.applicable !== false
    ));
  }

  function getCartItemUnitPrice(item) {
    return Number(item?.final_price ?? item?.price ?? 0);
  }

  function getCartItemOriginalUnitPrice(item) {
    const quantity = Math.max(1, Number(item?.quantity || 1));
    const originalLine = Number(item?.original_line_price || 0);
    const originalUnit = Number(item?.original_price || 0);
    return originalUnit || (originalLine > 0 ? Math.round(originalLine / quantity) : 0) || Number(item?.price || 0) || getCartItemUnitPrice(item);
  }

  function hasRealLineDiscount(item) {
    const originalUnit = getCartItemOriginalUnitPrice(item);
    const currentUnit = getCartItemUnitPrice(item);
    const originalLine = Number(item?.original_line_price || 0);
    const finalLine = Number(item?.final_line_price ?? item?.line_price ?? 0);
    return originalUnit > currentUnit || originalLine > finalLine;
  }

  function applyDisplayedPrice(item, variantCompareAtPrice) {
    const currentUnit = getCartItemUnitPrice(item);
    const originalUnit = getCartItemOriginalUnitPrice(item);
    const hasRealDiscount = hasRealLineDiscount(item);

    // Shopify owns eligibility, combinations and the best applicable discount.
    item.__aic_display_price = currentUnit;
    item.__aic_compare_at_price = Math.max(Number(variantCompareAtPrice || 0), hasRealDiscount ? originalUnit : 0);
  }

  async function enrichCartCompareAtPrices() {
    if (!cart?.items?.length) return;
    await Promise.all(cart.items.map(async (item) => {
      const handle = item.handle || item.product_handle;
      const variantId = Number(item.variant_id || item.id || 0);
      if (!handle || !variantId) {
        applyDisplayedPrice(item, 0);
        return;
      }
      const cacheKey = `${handle}:${variantId}`;
      let compareAtPrice = 0;
      if (productVariantPriceCache.has(cacheKey)) {
        compareAtPrice = productVariantPriceCache.get(cacheKey);
      } else {
        try {
          const response = await fetch(`${ROOT}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Product ${handle} lookup failed`);
          const product = await response.json();
          const variant = product?.variants?.find((entry) => Number(entry.id) === variantId);
          compareAtPrice = Number(variant?.compare_at_price || 0);
        } catch (_) {
          compareAtPrice = 0;
        }
        productVariantPriceCache.set(cacheKey, compareAtPrice);
      }
      applyDisplayedPrice(item, compareAtPrice);
    }));
  }

  function productRows() {
    return cart.items.map((item) => {
      const title = item.variant_title && item.variant_title !== 'Default Title'
        ? `${item.product_title} · ${item.variant_title}`
        : item.product_title;
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">`
        : '<span class="aic-product-placeholder"></span>';
      const unitPrice = item.__aic_display_price ?? getCartItemUnitPrice(item);
      const compareAtPrice = Number(item.__aic_compare_at_price || 0);
      const hasCompareAtSale = CONFIG.showCompareAt && compareAtPrice > unitPrice;
      const priceHtml = hasCompareAtSale
        ? `<span class="aic-product-price aic-product-price-sale"><s>${money(compareAtPrice, cart.currency)}</s><b>${money(unitPrice, cart.currency)}</b><em>/ бр.</em></span>`
        : `<span class="aic-product-price"><b>${money(unitPrice, cart.currency)}</b><em>/ бр.</em></span>`;

      return `<div class="aic-product" data-aic-line="${escapeHtml(item.key)}">
        ${image}
        <div class="aic-product-copy">
          <strong>${escapeHtml(title)}</strong>
          ${priceHtml}
          <button type="button" class="aic-remove" data-aic-remove="${escapeHtml(item.key)}" ${busy ? 'disabled' : ''}>Премахни</button>
        </div>
        <div class="aic-qty">
          <button type="button" data-aic-change="${escapeHtml(item.key)}" data-aic-quantity="${Math.max(0, item.quantity - 1)}" ${busy ? 'disabled' : ''}>−</button>
          <span>${item.quantity}</span>
          <button type="button" data-aic-change="${escapeHtml(item.key)}" data-aic-quantity="${item.quantity + 1}" ${busy ? 'disabled' : ''}>+</button>
        </div>
      </div>`;
    }).join('');
  }

  function cartCompareAtTotal() {
    if (!cart?.items?.length) return 0;
    return cart.items.reduce((sum, item) => {
      const quantity = Number(item.quantity || 0);
      const currentUnit = item.__aic_display_price ?? getCartItemUnitPrice(item);
      const compareAtUnit = Number(item.__aic_compare_at_price || 0);
      const effectiveOriginalUnit = CONFIG.showCompareAt && compareAtUnit > currentUnit ? compareAtUnit : currentUnit;
      return sum + (effectiveOriginalUnit * quantity);
    }, 0);
  }

  function cartTotalForDisplay() {
    // Never subtract theme percentages from Shopify's already discounted total.
    return Number(cart?.total_price || 0);
  }

  function activeManualDiscountCodes() {
    return (cart?.discount_codes || [])
      .filter((entry) => entry && entry.applicable !== false && String(entry.code || '').trim())
      .map((entry) => String(entry.code).trim());
  }

  function collectActiveDiscounts() {
    if (!cart) return [];
    const entries = new Map();
    const add = ({ key, title, type, amount = 0, removable = false, code = '' }) => {
      if (!key || !title) return;
      const existing = entries.get(key);
      if (existing) {
        existing.amount += Number(amount || 0);
        existing.removable = existing.removable || removable;
        return;
      }
      entries.set(key, { key, title, type, amount: Number(amount || 0), removable, code });
    };

    (cart.discount_codes || []).forEach((entry) => {
      const code = String(entry?.code || '').trim();
      if (!code || entry?.applicable === false) return;
      add({ key: `code:${code.toLowerCase()}`, title: code, type: 'code', removable: true, code });
    });

    const cartLevelKeys = new Set();
    (cart.cart_level_discount_applications || []).forEach((entry) => {
      const app = entry?.discount_application || entry?.discountApplication || entry || {};
      const type = String(app?.type || 'automatic');
      const title = String(app?.title || app?.code || (type === 'discount_code' ? 'Промокод' : 'Автоматична отстъпка')).trim();
      const amount = Number(entry?.amount || app?.total_allocated_amount || 0);
      const key = type === 'discount_code'
        ? `code:${title.toLowerCase()}`
        : `auto:${type}:${title.toLowerCase()}`;
      cartLevelKeys.add(key);
      add({
        key,
        title,
        type: type === 'discount_code' ? 'code' : 'automatic',
        amount,
        removable: type === 'discount_code',
        code: type === 'discount_code' ? title : ''
      });
    });

    (cart.items || []).forEach((item) => {
      const allocations = item?.line_level_discount_allocations || item?.discount_allocations || [];
      allocations.forEach((allocation) => {
        const app = allocation?.discount_application || allocation?.discountApplication || {};
        const type = String(app?.type || 'automatic');
        const title = String(app?.title || app?.code || (type === 'discount_code' ? 'Промокод' : 'Автоматична отстъпка')).trim();
        const amount = Number(allocation?.amount || allocation?.discounted_amount || 0);
        const key = type === 'discount_code'
          ? `code:${title.toLowerCase()}`
          : `auto:${type}:${title.toLowerCase()}`;
        if (cartLevelKeys.has(key)) return;
        add({ key, title, type: type === 'discount_code' ? 'code' : 'automatic', amount, removable: type === 'discount_code', code: type === 'discount_code' ? title : '' });
      });
    });

    return [...entries.values()];
  }

  function rejectedDiscountMessage(attemptedCode) {
    const names = [...new Set(collectActiveDiscounts()
      .filter((entry) => entry.amount > 0 && entry.title.toLowerCase() !== attemptedCode.toLowerCase())
      .map((entry) => `„${entry.title}“`))];
    const rejected = `Кодът „${attemptedCode}“ не е приложен.`;
    if (!names.length) return `${rejected} Проверете условията на кода.`;
    // The cart identifies applied discounts, but doesn't report why a code failed.
    const active = names.length === 1 ? 'Вече е приложена отстъпката' : 'Вече са приложени отстъпките';
    return `${rejected} ${active} ${names.join(', ')}. Прилагането зависи от условията за отстъпките.`;
  }

  function discountsHtml() {
    const active = CONFIG.showActiveDiscounts ? collectActiveDiscounts() : [];
    if (!CONFIG.showDiscountCodeField && !active.length) return '';
    const activeHtml = active.length ? `<div class="aic-discount-active-list">${active.map((entry) => `
      <div class="aic-discount-active" data-aic-discount-active>
        <span class="aic-discount-tag">${entry.type === 'automatic' ? 'Автоматично' : 'Промокод'}</span>
        <span class="aic-discount-name">${escapeHtml(entry.title)}</span>
        ${entry.amount > 0 ? `<strong>−${money(entry.amount, cart.currency)}</strong>` : ''}
        ${entry.removable && entry.code ? `<button type="button" class="aic-discount-remove" data-aic-discount-remove="${escapeHtml(entry.code)}" aria-label="Премахни ${escapeHtml(entry.code)}">×</button>` : ''}
      </div>`).join('')}</div>` : '';
    const fieldHtml = CONFIG.showDiscountCodeField ? `<form class="aic-discount-form" data-aic-discount-form novalidate>
      <input type="text" data-aic-discount-input value="${escapeHtml(discountInputDraft)}" placeholder="Промокод" autocomplete="off" ${discountBusy ? 'disabled' : ''}>
      <button type="submit" ${discountBusy ? 'disabled' : ''}>${discountBusy ? '...' : 'Приложи'}</button>
    </form>` : '';
    const feedbackHtml = discountFeedback?.text ? `<div class="aic-discount-feedback is-${discountFeedback.type === 'error' ? 'error' : 'success'}" role="status">${escapeHtml(discountFeedback.text)}</div>` : '';
    return `<div class="aic-discounts" data-aic-discounts>${activeHtml}${fieldHtml}${feedbackHtml}</div>`;
  }

  function snapshotVisibleCustomerDraft() {
    const form = document.querySelector('[data-aic-details-form]');
    if (!form) return;
    const data = new FormData(form);
    customerDraft = {
      firstName: String(data.get('first_name') || customerDraft.firstName || '').trim(),
      lastName: String(data.get('last_name') || customerDraft.lastName || '').trim(),
      phone: String(data.get('phone') || customerDraft.phone || '').trim(),
      email: String(data.get('email') || customerDraft.email || '').trim(),
    };
  }

  function restoreCheckoutAfterDiscount({ wasOpen, scrollTop }) {
    requestAnimationFrame(() => {
      const thread = document.querySelector('[data-aic-thread]');
      if (thread && Number.isFinite(scrollTop)) thread.scrollTop = scrollTop;
      if (!wasOpen || step !== 'details') return;

      if (CONFIG.paymentOptionsDisplay === 'after_button') {
        try { showCheckoutIframe(); } catch (_) {}
      } else {
        syncInlinePaymentOptions();
      }
    });
  }

  async function updateCartDiscountCodes(codes, attemptedCode = '') {
    if (discountBusy) return;
    const checkoutWasOpen = !!document.querySelector('[data-aic-checkout-frame]');
    const threadBefore = document.querySelector('[data-aic-thread]');
    const previousScrollTop = threadBefore?.scrollTop ?? 0;
    snapshotVisibleCustomerDraft();

    discountBusy = true;
    discountFeedback = null;
    if (!checkoutWasOpen) render();
    else {
      document.querySelectorAll('[data-aic-discount-form] input, [data-aic-discount-form] button, [data-aic-discount-remove]').forEach((control) => { control.disabled = true; });
    }

    try {
      const uniqueCodes = [...new Map(codes.map((code) => [String(code).trim().toLowerCase(), String(code).trim()])).values()].filter(Boolean);
      cart = await cartRequest('/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: uniqueCodes.join(',') })
      });
      await enrichCartCompareAtPrices();
      syncThemeCount();
      if (attemptedCode) {
        const result = (cart.discount_codes || []).find((entry) => String(entry?.code || '').toLowerCase() === attemptedCode.toLowerCase());
        if (!result || result.applicable === false) {
          discountFeedback = { type: 'error', text: rejectedDiscountMessage(attemptedCode) };
        } else {
          discountInputDraft = '';
          discountFeedback = { type: 'success', text: 'Промокодът е приложен.' };
        }
      } else {
        discountFeedback = { type: 'success', text: 'Промокодът е премахнат.' };
      }
    } catch (error) {
      discountFeedback = { type: 'error', text: error instanceof Error ? error.message : 'Не успяхме да приложим промокода.' };
    } finally {
      discountBusy = false;
      render();
      restoreCheckoutAfterDiscount({ wasOpen: checkoutWasOpen, scrollTop: previousScrollTop });
    }
  }

  async function applyDiscountCode(code) {
    const value = String(code || '').trim();
    if (!value) {
      discountFeedback = { type: 'error', text: 'Въведете промокод.' };
      render();
      return;
    }
    discountInputDraft = value;
    const existing = activeManualDiscountCodes();
    await updateCartDiscountCodes([...existing, value], value);
  }

  async function removeDiscountCode(code) {
    const value = String(code || '').trim();
    const remaining = activeManualDiscountCodes().filter((entry) => entry.toLowerCase() !== value.toLowerCase());
    await updateCartDiscountCodes(remaining);
  }

  function userCartMessage() {
    const compareAtTotal = cartCompareAtTotal();
    const displayedTotal = cartTotalForDisplay();
    const savings = Math.max(0, compareAtTotal - displayedTotal);
    const hasSavings = CONFIG.showSavings && savings > 0;
    const totalPriceHtml = hasSavings
      ? `<span class="aic-total-prices"><s>${money(compareAtTotal, cart.currency)}</s><strong>${money(displayedTotal, cart.currency)}</strong></span>`
      : `<strong>${money(displayedTotal, cart.currency)}</strong>`;
    const hasCartHeading = Boolean(String(CONFIG.cartHeading || '').trim());
    return `<section class="aic-turn aic-flow-section aic-cart-step">
      <div class="aic-user-bubble${hasCartHeading ? '' : ' aic-user-bubble-no-heading'}">
        ${hasCartHeading ? `<div class="aic-flow-title">${escapeHtml(CONFIG.cartHeading)}</div>` : ''}
        <div class="aic-products">${productRows()}</div>
        ${discountsHtml()}
        <div class="aic-total-row"><span>Общо</span>${totalPriceHtml}</div>
        ${hasSavings ? `<div class="aic-savings">Вие спестявате ${money(savings, cart.currency)}</div>` : ''}
        <button class="aic-send${step === 'cart' ? '' : ' is-sent'}" type="button" data-aic-start ${busy || discountBusy || step !== 'cart' ? 'disabled' : ''}>
          ${step === 'cart' ? 'Искам да поръчам <span>→</span>' : 'Избрано <span>✓</span>'}
        </button>
      </div>
    </section>`;
  }

  function detailsTurn() {
    if (step !== 'details') return '';
    return `<section class="aic-turn aic-flow-section aic-details-step">
      ${checkoutProgressHtml(3)}
      <div class="aic-flow-copy" data-aic-details-start>
        <strong>${escapeHtml(CONFIG.detailsHeading)}</strong>
        <span>${escapeHtml(CONFIG.detailsText)}</span>
      </div>
      <form class="aic-form" data-aic-details-form novalidate>
        <div class="aic-form-grid">
          <label><span>Име</span><input name="first_name" autocomplete="given-name" value="${escapeHtml(customerDraft.firstName)}" required></label>
          <label><span>Фамилия</span><input name="last_name" autocomplete="family-name" value="${escapeHtml(customerDraft.lastName)}" required></label>
          <label><span>Телефон</span><input name="phone" type="tel" autocomplete="tel" value="${escapeHtml(customerDraft.phone)}" required></label>
          <label><span>Имейл</span><input name="email" type="email" autocomplete="email" inputmode="email" value="${escapeHtml(customerDraft.email)}" required></label>
          ${CONFIG.deliveryHeading || CONFIG.deliveryText ? `<div class="aic-form-wide aic-flow-copy aic-delivery-copy">${CONFIG.deliveryHeading ? `<strong>${escapeHtml(CONFIG.deliveryHeading)}</strong>` : ''}${CONFIG.deliveryText ? `<span>${escapeHtml(CONFIG.deliveryText)}</span>` : ''}</div>` : ''}
          <div class="aic-form-wide aic-shipping-field">
            ${CONFIG.deliveryHeading || CONFIG.deliveryText ? '' : '<span class="aic-field-label">Доставка</span>'}
            <div class="aic-shipping-inline-loading" data-aic-shipping-loading>Зареждам опциите за доставка…</div>
            <div class="aic-shipping-inline" data-aic-shipping-inline></div>
          </div>
          <div class="aic-form-wide aic-validation-message" data-aic-validation-message role="alert" hidden>Моля, попълнете всички данни.</div>
          <div class="aic-form-wide aic-inline-payment" data-aic-inline-payment></div>
          ${CONFIG.paymentOptionsDisplay === 'after_button' ? '<button type="submit" class="aic-done" disabled>Продължи към плащане <span>→</span></button>' : ''}
        </div>
      </form>
    </section>`;
  }

  function detailsSentTurn() {
    if (step !== 'payment') return '';
    const fullName = [customerDraft.firstName, customerDraft.lastName].filter(Boolean).join(' ');
    const shippingTitle = shippingSelection?.location || shippingSelection?.courierName || 'Избрана доставка';
    const shippingAddress = shippingSelection?.address || '';
    return `<section class="aic-turn aic-turn-user aic-turn-compact aic-details-summary-turn">
      ${checkoutProgressHtml(3)}
      <div class="aic-details-heading">Данни за доставка</div>
      <div class="aic-order-summary">
        <div class="aic-summary-row">
          <span class="aic-summary-icon">◉</span>
          <span class="aic-summary-copy"><strong>${escapeHtml(fullName)}</strong><small>${escapeHtml(customerDraft.phone)}${customerDraft.email ? ` · ${escapeHtml(customerDraft.email)}` : ''}</small></span>
        </div>
        <div class="aic-summary-row">
          <span class="aic-summary-icon">⌖</span>
          <span class="aic-summary-copy"><strong>${escapeHtml(shippingTitle)}</strong>${shippingAddress ? `<small>${escapeHtml(shippingAddress)}</small>` : ''}</span>
        </div>
      </div>
    </section>`;
  }

  function paymentTurn() {
    if (step !== 'payment') return '';
    const cod = isEcontShipping()
      ? `<button type="button" class="aic-payment-option" data-aic-payment="cod">
          <span class="aic-payment-copy"><strong>Наложен платеж</strong><small>Плащане при получаване с Еконт</small></span>
          <span class="aic-payment-arrow">→</span>
        </button>`
      : '';
    return `<section class="aic-turn aic-flow-section aic-payment-turn">
      <div class="aic-flow-copy">
        <strong>${escapeHtml(CONFIG.paymentHeading)}</strong>
        <span>${escapeHtml(CONFIG.paymentText)}</span>
      </div>
      <div class="aic-payment-options">
        <button type="button" class="aic-payment-option is-primary" data-aic-payment="card">
          <span class="aic-payment-copy"><strong>Плащане с карта</strong><small>Сигурно плащане през Shopify Checkout</small></span>
          <span class="aic-payment-arrow">→</span>
        </button>
        ${cod}
      </div>
      ${CONFIG.paymentOptionsDisplay === 'after_button' ? `<div class="aic-inline-checkout-host" data-aic-inline-checkout-host hidden>
        <div class="aic-flow-copy aic-payment-intro"><strong>${escapeHtml(CONFIG.paymentHeading)}</strong><span>${escapeHtml(CONFIG.paymentText)}</span></div>
        <div data-aic-inline-checkout-frame-host></div>
      </div>` : ''}
    </section>`;
  }

  function checkoutProgressHtml(activeStep) {
    const current = Number(activeStep) === 3 ? 3 : 2;
    return `<div class="aic-progress" aria-label="Стъпка ${current} от 3">
      <div class="aic-progress-meta">Стъпка ${current} от 3</div>
      <div class="aic-progress-steps" role="list">
        <div class="aic-progress-step is-complete" role="listitem"><span>✓</span><small>Количка</small></div>
        <div class="aic-progress-line${current === 3 ? ' is-complete' : ''}"></div>
        <div class="aic-progress-step ${current === 2 ? 'is-current' : 'is-complete'}" role="listitem"><span>${current === 3 ? '✓' : '2'}</span><small>Оферта</small></div>
        <div class="aic-progress-line${current === 3 ? ' is-complete' : ''}"></div>
        <div class="aic-progress-step ${current === 3 ? 'is-current' : ''}" role="listitem"><span>3</span><small>Данни</small></div>
      </div>
    </div>`;
  }

  function upsellSavingsCopy(upsell) {
    const template = String(CONFIG.upsellSavingsCopy ?? DEFAULT_CONFIG.upsellSavingsCopy).trim();
    if (!template) return '';
    return template.replaceAll('{amount}', money(upsell.savings, cart?.currency));
  }

  function upsellItemHtml(upsell, layout, useListCheckboxes) {
    const imageContent = upsell.image
      ? `<img src="${escapeHtml(upsell.image)}" alt="${escapeHtml(upsell.title)}" loading="eager">`
      : '<span class="aic-upsell-image-placeholder"></span>';
    const productUrl = String(upsell.url || '').trim();
    const productLinksEnabled = CONFIG.upsellProductLinks !== false && productUrl;
    const image = productLinksEnabled
      ? `<a class="aic-upsell-image-link" href="${escapeHtml(productUrl)}" aria-label="${escapeHtml(upsell.title)}">${imageContent}</a>`
      : imageContent;
    const title = productLinksEnabled
      ? `<a class="aic-upsell-title-link" href="${escapeHtml(productUrl)}"><strong>${escapeHtml(upsell.title)}</strong></a>`
      : `<strong>${escapeHtml(upsell.title)}</strong>`;
    const offerCopy = upsell.discountCode && !upsell.added
      ? 'Отстъпката се проверява при добавяне в количката.'
      : '';
    const savingsCopy = upsell.savings > 0 ? upsellSavingsCopy(upsell) : '';
    const isAdded = upsell.added === true;
    const isSelected = isAdded || upsellSelectedKeys.has(upsell.key);
    const buttonCopy = isAdded ? 'Добавено' : (CONFIG.upsellAddCopy || DEFAULT_CONFIG.upsellAddCopy);
    return `<article class="aic-upsell-item${isAdded ? ' is-added' : ''}" data-aic-upsell-item="${escapeHtml(upsell.key)}">
      ${offerCopy ? `<div class="aic-upsell-item-offer">${offerCopy}</div>` : ''}
      ${useListCheckboxes ? `<label class="aic-upsell-checkbox">
        <input type="checkbox" data-aic-upsell-select="${escapeHtml(upsell.key)}" aria-label="Избери ${escapeHtml(upsell.title)}" ${isSelected ? 'checked' : ''} ${busy || isAdded ? 'disabled' : ''}>
        <span aria-hidden="true"></span>
      </label>` : ''}
      <div class="aic-upsell-product">
        <div class="aic-upsell-image">${image}</div>
        <div class="aic-upsell-copy">
          ${title}
          <div class="aic-upsell-prices">${upsell.savings > 0 ? `<s>${money(upsell.price, cart.currency)}</s>` : ''}<b>${money(upsell.discountedPrice, cart.currency)}</b></div>
          ${savingsCopy ? `<span class="aic-upsell-saving">${escapeHtml(savingsCopy)}</span>` : ''}
        </div>
      </div>
      ${useListCheckboxes ? '' : `<div class="aic-upsell-item-actions">
        <button type="button" class="aic-send${isAdded ? ' is-added' : ''}" data-aic-upsell-add="${escapeHtml(upsell.key)}" ${busy || isAdded ? 'disabled' : ''}>${escapeHtml(buttonCopy)} <span>${isAdded ? '✓' : '→'}</span></button>
      </div>`}
    </article>`;
  }

  function upsellTurn() {
    if (step !== 'upsell') return '';
    const upsells = getUpsellProducts();
    if (!upsells.length) return '';
    const layout = CONFIG.upsellLayout === 'grid' ? 'grid' : 'list';
    const useListCheckboxes = layout === 'list' && CONFIG.upsellListUseCheckboxes !== false;
    if (useListCheckboxes && !upsellSelectionInitialized) {
      upsellSelectedKeys.clear();
      if (CONFIG.upsellPreselectAll === true) {
        upsells.filter((upsell) => !upsell.added).forEach((upsell) => upsellSelectedKeys.add(upsell.key));
      }
      upsellSelectionInitialized = true;
    }
    const selectedUpsells = useListCheckboxes
      ? upsells.filter((upsell) => !upsell.added && upsellSelectedKeys.has(upsell.key))
      : [];
    const allUpsellsAdded = useListCheckboxes && upsells.every((upsell) => upsell.added);
    const badgeCopy = String(CONFIG.upsellBadge ?? DEFAULT_CONFIG.upsellBadge).trim();
    const headingCopy = String(CONFIG.upsellHeading ?? DEFAULT_CONFIG.upsellHeading).trim();
    const introCopy = String(CONFIG.upsellIntro ?? DEFAULT_CONFIG.upsellIntro).trim();
    const skipCopy = String(CONFIG.upsellSkipCopy ?? DEFAULT_CONFIG.upsellSkipCopy).trim();
    return `<section class="aic-turn aic-flow-section aic-upsell-step">
      ${checkoutProgressHtml(2)}
      <div class="aic-upsell-card">
        ${badgeCopy ? `<div class="aic-upsell-badge">${escapeHtml(badgeCopy)}</div>` : ''}
        ${headingCopy || introCopy ? `<div class="aic-flow-copy">
          ${headingCopy ? `<strong>${escapeHtml(headingCopy)}</strong>` : ''}
          ${introCopy ? `<span>${escapeHtml(introCopy)}</span>` : ''}
        </div>` : ''}
        <div class="aic-upsell-collection is-${layout}${useListCheckboxes ? ' uses-checkboxes' : ''}${upsells.length === 1 ? ' has-one' : ''}">
          ${upsells.map((upsell) => upsellItemHtml(upsell, layout, useListCheckboxes)).join('')}
        </div>
        ${useListCheckboxes ? `<button type="button" class="aic-send aic-upsell-add-selected${allUpsellsAdded ? ' is-added' : ''}" data-aic-upsell-add-selected ${busy || selectedUpsells.length === 0 ? 'disabled' : ''}>${allUpsellsAdded ? 'Добавено' : 'Добави избраните'} <span>${allUpsellsAdded ? '✓' : '→'}</span></button>` : ''}
        ${skipCopy ? `<button type="button" class="aic-upsell-skip" data-aic-upsell-skip ${busy ? 'disabled' : ''}>${escapeHtml(skipCopy)}</button>` : ''}
      </div>
    </section>`;
  }

  function shippingDetailsReady() {
    if (!shippingSelection) return false;
    if (shippingSelection.method === 'ADDRESS') {
      return shippingAddressStatus.state === 'valid' && Boolean(shippingAddressDraft.city.trim() && shippingAddressDraft.zip.trim() && shippingAddressDraft.address1.trim());
    }
    return Boolean(shippingSelection.pickupPoint && !shippingEditing);
  }

  function shippingSelectionStateConsistent() {
    if (!shippingSelection) return false;
    if (shippingSelection.method !== shippingMethod) return false;
    if (!shippingSelection.handle || !shippingSelection.courierName) return false;
    if (shippingSelection.method === 'ADDRESS') return shippingAddressStatus.state === 'valid';
    return Boolean(shippingSelection.pickupPoint && !shippingEditing);
  }

  function checkoutRequirementsState() {
    const form = document.querySelector('[data-aic-details-form]');
    const names = ['first_name', 'last_name', 'phone', 'email'];
    const draftValues = {
      first_name: customerDraft.firstName,
      last_name: customerDraft.lastName,
      phone: customerDraft.phone,
      email: customerDraft.email,
    };
    const fields = {};
    names.forEach((name) => {
      const input = form?.querySelector(`[name="${name}"]`) || null;
      const value = input?.value.trim() || String(draftValues[name] || '').trim();
      fields[name] = { input, invalid: !value || (input ? !input.checkValidity() : false) };
    });
    const shippingReady = shippingDetailsReady();
    const shippingConsistent = shippingReady && shippingSelectionStateConsistent();
    const detailsReady = Boolean(form) || names.every((name) => !fields[name].invalid);
    return {
      form,
      fields,
      shippingInvalid: !shippingReady || !shippingConsistent,
      shippingConsistent,
      valid: detailsReady && !Object.values(fields).some((entry) => entry.invalid) && shippingReady && shippingConsistent,
    };
  }

  function checkoutValidationErrorsVisible() {
    const parentMessage = document.querySelector('[data-aic-validation-message]');
    if (parentMessage && !parentMessage.hidden) return true;
    const frame = document.querySelector('[data-aic-inline-payment] [data-aic-checkout-frame]');
    try {
      const iframeMessage = frame?.contentDocument?.querySelector('[data-aic-checkout-validation-message]');
      return Boolean(iframeMessage && !iframeMessage.hidden);
    } catch (_) {
      return false;
    }
  }

  function syncCheckoutValidationMessage(show, text = 'Моля, попълнете всички данни.') {
    const frame = document.querySelector('[data-aic-inline-payment] [data-aic-checkout-frame]');
    try {
      const doc = frame?.contentDocument;
      const payButton = doc?.getElementById('checkout-pay-button');
      if (!doc || !payButton) return false;

      let message = doc.querySelector('[data-aic-checkout-validation-message]');
      if (!message) {
        message = doc.createElement('div');
        message.setAttribute('data-aic-checkout-validation-message', '');
        message.setAttribute('role', 'alert');
        message.textContent = text;
        Object.assign(message.style, {
          marginTop: '10px',
          padding: '9px 10px',
          border: '1px solid rgba(200,66,66,.45)',
          borderRadius: '3px',
          background: 'rgba(200,66,66,.05)',
          color: '#b73535',
          fontSize: '12px',
          lineHeight: '1.35',
          textAlign: 'center',
          fontWeight: '600',
        });
        payButton.insertAdjacentElement('afterend', message);
      } else if (message.previousElementSibling !== payButton) {
        payButton.insertAdjacentElement('afterend', message);
      }
      message.textContent = text;
      message.hidden = !show;
      if (frame) scheduleCheckoutViewport(frame);
      return true;
    } catch (_) {
      return false;
    }
  }

  function validateCheckoutRequirements({ showErrors = false, focusFirst = false } = {}) {
    const state = checkoutRequirementsState();
    const message = document.querySelector('[data-aic-validation-message]');
    const shippingField = document.querySelector('.aic-shipping-field');

    Object.values(state.fields).forEach(({ input, invalid }) => {
      if (!input) return;
      input.classList.toggle('is-invalid', showErrors && invalid);
      input.closest('label')?.classList.toggle('is-invalid', showErrors && invalid);
      if (showErrors && invalid) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    });
    shippingField?.classList.toggle('is-invalid', showErrors && state.shippingInvalid);
    const showValidationMessage = showErrors && !state.valid;
    const shownInsideCheckout = syncCheckoutValidationMessage(showValidationMessage);
    if (message) message.hidden = !(showValidationMessage && !shownInsideCheckout);

    if (showErrors && !state.valid && focusFirst) {
      const firstInvalid = Object.values(state.fields).find((entry) => entry.invalid)?.input;
      requestAnimationFrame(() => (firstInvalid || shippingField)?.focus?.({ preventScroll: true }));
    }
    return state.valid;
  }

  function customerDetailsReady() {
    return validateCheckoutRequirements({ showErrors: false });
  }

  function syncLiveCheckoutPrefill() {
    const frame = document.querySelector('[data-aic-inline-payment] [data-aic-checkout-frame]');
    if (!frame || !frame.contentDocument) return false;
    const synced = prefillShopifyCheckout(frame);
    if (synced) scheduleCheckoutViewport(frame);
    return synced;
  }

  function mountInstantPaymentIframe() {
    const drawer = document.querySelector('[data-aic-drawer]');
    const host = document.querySelector('[data-aic-inline-payment]');
    const frameHost = host?.querySelector('[data-aic-inline-checkout-frame-host]');
    if (!drawer?.classList.contains('is-open') || !host?.isConnected || !frameHost) return;

    let frame = frameHost.querySelector('[data-aic-checkout-frame]');
    if (frame) {
      syncLiveCheckoutPrefill();
      return;
    }

    frameHost.innerHTML = `<div class="aic-checkout-frame-shell aic-checkout-frame-shell-inline aic-checkout-frame-shell-instant">
      <iframe class="aic-checkout-frame aic-checkout-frame-inline" data-aic-checkout-frame src="${ROOT}checkout" title="Shopify Checkout" allow="payment *"></iframe>
    </div>`;
    frame = frameHost.querySelector('[data-aic-checkout-frame]');
    frame?.addEventListener('load', () => {
      prefillShopifyCheckout(frame);
      setTimeout(() => prefillShopifyCheckout(frame), 180);
      scheduleCheckoutShippingSync(frame);
      scheduleCheckoutPaymentSync(frame);
      scheduleCheckoutViewport(frame);
      setTimeout(() => scheduleCheckoutViewport(frame), 350);
      setTimeout(() => scheduleCheckoutViewport(frame), 900);
    }, { once: true });
  }

  function queueInstantPaymentMount() {
    if (queueInstantPaymentMount.pending) return;
    queueInstantPaymentMount.pending = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      queueInstantPaymentMount.pending = false;
      mountInstantPaymentIframe();
    }));
  }

  function customerDraftComplete() {
    return Boolean(
      customerDraft.firstName.trim()
      && customerDraft.lastName.trim()
      && customerDraft.phone.trim()
      && customerDraft.email.trim()
    );
  }

  function syncInlinePaymentOptions() {
    const host = document.querySelector('[data-aic-inline-payment]');
    if (!host) return;
    // Autofill may update visible values without sending an input event for each field.
    saveCustomerDraftFromForm();
    const checkoutReady = customerDraftComplete() && shippingDetailsReady() && shippingSelectionStateConsistent();

    if (!checkoutReady) {
      const frame = host.querySelector('[data-aic-checkout-frame]');
      if (frame) frame.remove();
      host.innerHTML = '<div class="aic-payment-pending">Попълнете данните и изберете потвърдена доставка, за да продължите към плащане.</div>';
      return;
    }

    if (CONFIG.paymentOptionsDisplay === 'after_button') {
      if (!host.querySelector('[data-aic-inline-checkout-host]')) {
        host.innerHTML = `<button type="button" class="aic-send aic-payment-cta" data-aic-payment="card">
          ${escapeHtml(CONFIG.checkoutCta)} <span>→</span>
        </button>
        <div class="aic-inline-checkout-host" data-aic-inline-checkout-host hidden>
          <div class="aic-flow-copy aic-payment-intro"><strong>${escapeHtml(CONFIG.paymentHeading)}</strong><span>${escapeHtml(CONFIG.paymentText)}</span></div>
          <div data-aic-inline-checkout-frame-host></div>
        </div>`;
      }
      const frame = host.querySelector('[data-aic-checkout-frame]');
      const paymentButton = host.querySelector('[data-aic-payment="card"]');
      if (!frame && paymentButton instanceof HTMLButtonElement) {
        paymentButton.disabled = false;
        paymentButton.innerHTML = `${escapeHtml(CONFIG.checkoutCta)} <span>→</span>`;
      } else if (frame) {
        syncLiveCheckoutPrefill();
        scheduleCheckoutPaymentSync(frame);
      }
      return;
    }

    if (!host.querySelector('[data-aic-inline-checkout-host-instant]')) {
      host.innerHTML = `<div class="aic-inline-checkout-host aic-inline-checkout-host-instant" data-aic-inline-checkout-host data-aic-inline-checkout-host-instant>
        <div class="aic-flow-copy aic-payment-intro"><strong>${escapeHtml(CONFIG.paymentHeading)}</strong><span>${escapeHtml(CONFIG.paymentText)}</span></div>
        <div data-aic-inline-checkout-frame-host></div>
      </div>`;
    }
    syncLiveCheckoutPrefill();
    queueInstantPaymentMount();
  }

  function shippingCartAttributes(selection = shippingSelection) {
    const point = selection?.pickupPoint || null;
    const pointDetails = point?.details || {};
    return {
      '__aic_shipping_method': selection?.method || '',
      '__aic_shipping_courier': selection?.courierName || '',
      '__aic_shipping_location': selection?.location || '',
      '__aic_shipping_address': selection?.address || '',
      '__aic_shipping_rate': selection?.rateName || selection?.handle || '',
      '__aic_shipping_location_id': pointDetails.locationOfficeId || '',
      '__aic_shipping_provider': point?.provider || (selection?.courierName || '').toLocaleLowerCase('bg-BG'),
      '__aic_shipping_city_id': selection?.cityId || '',
      '__aic_shipping_validated': selection && shippingDetailsReady() ? 'true' : 'false',
    };
  }

  function queueShippingCartAttributes(selection = shippingSelection) {
    const attributes = shippingCartAttributes(selection);
    shippingCartWrite = shippingCartWrite.catch(() => undefined).then(() => cartRequest('/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    }));
    return shippingCartWrite;
  }

  async function persistCheckoutContext(extraAttributes = {}) {
    await openAiUpdateKnownUser().catch(() => undefined);
    await shippingCartWrite.catch(() => undefined);
    const attributes = {
      '__aic_first_name': customerDraft.firstName,
      '__aic_last_name': customerDraft.lastName,
      '__aic_phone': customerDraft.phone,
      '__aic_email': customerDraft.email,
      '__openai_measurement_consent': openAiMeasurementAllowed() ? 'true' : 'false',
      ...shippingCartAttributes(),
      ...openAiAttributionCartAttributes(),
      ...extraAttributes
    };
    await cartRequest('/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });
  }

  async function completeDetails(form) {
    if (busy) return;
    const data = new FormData(form);
    customerDraft = {
      firstName: String(data.get('first_name') || '').trim(),
      lastName: String(data.get('last_name') || '').trim(),
      phone: String(data.get('phone') || '').trim(),
      email: String(data.get('email') || '').trim()
    };
    if (!form.reportValidity() || !validateCheckoutRequirements({ showErrors: true, focusFirst: true })) return;

    // Write the final cart attributes only when the customer hands off to
    // Shopify Checkout, after the delivery choice has been validated.
    step = 'payment';
    render();
  }

  function setCheckoutControlValue(control, value) {
    if (!control || value == null || value === '') return false;
    try {
      const proto = control instanceof HTMLSelectElement ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
      descriptor?.set?.call(control, String(value));
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
      control.dispatchEvent(new Event('blur', { bubbles: true }));
      return true;
    } catch (_) {
      try {
        control.value = String(value);
        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      } catch (_) { return false; }
    }
  }

  function checkoutShippingDraft() {
    const point = shippingSelection?.pickupPoint || null;
    const pointAddress = point?.address || {};
    const pointDetails = point?.details || {};
    const isAddress = shippingSelection?.method === 'ADDRESS';
    const address1 = isAddress
      ? (shippingSelection?.normalizedAddress || shippingAddressDraft.address1 || '')
      : (pointAddress.address1 || pointAddress.address || shippingSelection?.address?.split(',')[0] || shippingSelection?.location || '');
    const city = isAddress
      ? (shippingAddressDraft.city || shippingAddressDraft.cityRecord?.name || '')
      : (pointAddress.city || pointAddress.cityName || pointDetails.city || '');
    const postalCode = isAddress
      ? (shippingAddressDraft.zip || shippingAddressDraft.cityRecord?.postCode || '')
      : (pointAddress.postalCode || pointAddress.postcode || pointAddress.postCode || pointAddress.zip || pointAddress.zipCode || pointDetails.postalCode || pointDetails.postcode || pointDetails.zip || '');
    return { address1, city, postalCode };
  }

  function checkoutShippingRadioForSelection(frame) {
    try {
      const doc = frame?.contentDocument;
      const handle = String(shippingSelection?.handle || '').trim();
      const rateName = String(shippingSelection?.rateName || shippingSelection?.option?.name || handle).trim();
      if (!doc || !handle) return null;
      const normalizeRate = (value) => String(value || '').toLocaleLowerCase('bg-BG').replace(/\s+/g, ' ').trim();
      const expected = [handle, rateName].map(normalizeRate).filter(Boolean);
      return [...doc.querySelectorAll('input[name="shipping_methods"]')].find((radio) => {
        const label = radio.id ? doc.querySelector(`label[for="${CSS.escape(radio.id)}"]`) : null;
        const wrapper = radio.closest('label, [role="radio"], div');
        const searchable = normalizeRate([radio.id, radio.value, radio.getAttribute('data-shipping-method'), label?.textContent, wrapper?.textContent].filter(Boolean).join(' '));
        return expected.some((value) => searchable.includes(value));
      }) || null;
    } catch (_) {
      return null;
    }
  }

  function checkoutShippingMethodMatchesSelection(frame) {
    try {
      const radio = checkoutShippingRadioForSelection(frame);
      return Boolean(radio?.checked);
    } catch (_) {
      return false;
    }
  }

  function syncCheckoutShippingMethod(frame) {
    try {
      const radio = checkoutShippingRadioForSelection(frame);
      if (!radio) return false;
      if (!radio.checked) radio.click();
      return Boolean(radio.checked);
    } catch (_) {
      return false;
    }
  }

  function scheduleCheckoutShippingSync(frame) {
    [0, 180, 450, 900, 1500].forEach((delay) => {
      setTimeout(() => {
        syncCheckoutShippingMethod(frame);
        scheduleCheckoutViewport(frame);
      }, delay);
    });
  }

  function scheduleCheckoutPaymentSync(frame) {
    [0, 120, 300, 700, 1200, 1800].forEach((delay) => {
      setTimeout(() => {
        if (!frame?.isConnected) return;
        syncCheckoutPaymentAvailability(frame);
        syncCardBillingCheckbox(frame);
        scheduleCheckoutViewport(frame);
      }, delay);
    });
  }

  function resyncOpenCheckoutPayment() {
    const frame = document.querySelector('[data-aic-checkout-frame]');
    if (!frame) return;
    syncCheckoutPaymentAvailability(frame);
    syncCardBillingCheckbox(frame);
    scheduleCheckoutPaymentSync(frame);
  }

  function prefillShopifyCheckout(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc) return false;
      const shipping = checkoutShippingDraft();
      const values = {
        email: customerDraft.email,
        firstName: customerDraft.firstName,
        lastName: customerDraft.lastName,
        address1: shipping.address1,
        postalCode: shipping.postalCode,
        city: shipping.city,
        phone: customerDraft.phone,
      };
      Object.entries(values).forEach(([name, value]) => {
        const input = doc.querySelector(`[name="${name}"]`);
        setCheckoutControlValue(input, value);
      });
      const country = doc.querySelector('[name="countryCode"]');
      if (country) setCheckoutControlValue(country, 'BG');
      const billingSame = doc.querySelector('input[name="billing_address_selector"][value="on"]:not(:checked)');
      billingSame?.click?.();
      syncCheckoutShippingMethod(frame);
      syncCheckoutPaymentAvailability(frame);
      return true;
    } catch (_) { return false; }
  }

  function syncCardBillingCheckbox(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc) return;

      if (!frame.__aicPaymentMethodListener) {
        const onChange = (event) => {
          const target = event.target;
          if (!target || target.tagName !== 'INPUT' || target.type !== 'radio' || target.name !== 'basic') return;
          setTimeout(() => {
            syncCardBillingCheckbox(frame);
            scheduleCheckoutViewport(frame);
          }, 0);
        };
        doc.addEventListener('change', onChange, true);
        frame.__aicPaymentMethodListener = onChange;
      }

      const checkbox = doc.getElementById('billingAddressCheckbox');
      const details = doc.getElementById('billingAddressDetails');
      if (!checkbox || !details) return;

      let wrapper = checkbox.parentElement;
      while (wrapper && wrapper !== doc.body && !wrapper.contains(details)) wrapper = wrapper.parentElement;
      if (!wrapper || wrapper.nodeType !== 1 || wrapper === doc.body) return;

      const cardSelected = !!doc.getElementById('basic-creditCards')?.checked;
      const shouldHide = CONFIG.hideBilling && cardSelected;
      if (shouldHide) {
        wrapper.style.setProperty('display', 'none', 'important');
      } else {
        wrapper.style.removeProperty('display');
      }
      wrapper.dataset.aicCardBillingHidden = shouldHide ? 'true' : 'false';
    } catch (_) {}
  }

  function currentVisibleShippingCourier() {
    const active = document.querySelector('[data-aic-ship-option].is-active');
    return [
      active?.getAttribute('data-aic-ship-courier'),
      active?.textContent,
      shippingMethod,
      shippingOption?.courierName,
      shippingOption?.displayName,
      shippingOption?.title,
      shippingSelection?.method,
      shippingSelection?.courierName,
    ].filter(Boolean).join(' ');
  }

  function isEcontShipping() {
    const value = currentVisibleShippingCourier();
    return /econt|еконт/i.test(value) && !/box\s*now/i.test(value);
  }

  function isBoxNowShipping() {
    const method = String(shippingMethod || shippingSelection?.method || '').trim().toUpperCase();
    const value = currentVisibleShippingCourier();
    return method === 'BOX' || /box\s*now/i.test(value);
  }

  function syncCheckoutPaymentAvailability(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc) return;

      const codRadio = doc.querySelector('input[type="radio"][id^="basic-customManualPayment-"]');
      if (!codRadio) return;

      const collapsible = doc.getElementById(`${codRadio.id}-collapsible`);
      let optionWrapper = codRadio.parentElement;
      while (optionWrapper && optionWrapper !== doc.body && collapsible && !optionWrapper.contains(collapsible)) {
        optionWrapper = optionWrapper.parentElement;
      }
      if (!optionWrapper || optionWrapper === doc.body || optionWrapper.nodeType !== 1) return;

      const hideCod = isBoxNowShipping();
      const forceShowCod = isEcontShipping();
      if (hideCod) {
        const cardRadio = doc.getElementById('basic-creditCards');
        if (cardRadio && !cardRadio.checked) {
          cardRadio.click();
          cardRadio.dispatchEvent(new Event('input', { bubbles: true }));
          cardRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        optionWrapper.style.setProperty('display', 'none', 'important');
        optionWrapper.setAttribute('aria-hidden', 'true');
      } else if (forceShowCod) {
        optionWrapper.style.setProperty('display', 'block', 'important');
        optionWrapper.removeAttribute('aria-hidden');
      } else {
        optionWrapper.style.removeProperty('display');
        optionWrapper.removeAttribute('aria-hidden');
      }
      optionWrapper.dataset.aicCodHiddenForBoxNow = hideCod ? 'true' : 'false';
    } catch (_) {}
  }

  function installCheckoutRequirementsGuard(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc || frame.__aicRequirementsGuardInstalled) return;

      const stopEvent = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
      };

      const blockIfInvalid = (event) => {
        if (!validateCheckoutRequirements({ showErrors: true, focusFirst: true })) {
          stopEvent(event);
          return true;
        }
        if (!checkoutShippingMethodMatchesSelection(frame)) {
          stopEvent(event);
          syncCheckoutValidationMessage(true, 'Обновяваме избраната доставка. Моля, натиснете отново.');
          scheduleCheckoutShippingSync(frame);
          return true;
        }
        syncCheckoutValidationMessage(false);
        return false;
      };

      doc.addEventListener('pointerdown', (event) => {
        const target = event.target;
        const payButton = target?.closest?.('#checkout-pay-button');
        if (!payButton) return;
        blockIfInvalid(event);
      }, true);

      doc.addEventListener('click', (event) => {
        const target = event.target;
        const payButton = target?.closest?.('#checkout-pay-button');
        if (!payButton) return;
        blockIfInvalid(event);
      }, true);

      doc.addEventListener('submit', (event) => {
        blockIfInvalid(event);
      }, true);

      frame.__aicRequirementsGuardInstalled = true;
      if (checkoutValidationErrorsVisible()) {
        validateCheckoutRequirements({ showErrors: true });
      }
    } catch (_) {}
  }

  function applyCheckoutSimplifications(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc?.head) return;

      if (!doc.getElementById('aic-hide-prefill-sections')) {
        const selectors = [];
        if (CONFIG.hideExpressCheckout) selectors.push('form.km09ry0 > .km09ry1 > :first-child');
        if (CONFIG.hideContact) {
          selectors.push('form.km09ry0 > .km09ry1 > section[aria-label="Контакт"]');
          selectors.push('form.km09ry0 > .km09ry1 > section[aria-label="Контакт"] + div');
          selectors.push('form.km09ry0 > .km09ry1 > section[aria-label="Контакт"] + div + div');
        }
        if (CONFIG.hideDelivery) {
          selectors.push('form.km09ry0 > .km09ry1 > section[aria-label="Контакт"] + div + div + div');
          selectors.push('[role="group"][aria-labelledby="deliveryAddress"]');
          selectors.push('div.delivery-transition-content');
        }
        if (CONFIG.hideBilling) selectors.push('[role="group"][aria-labelledby="billingAddress"]');
        if (CONFIG.hideRememberMe) selectors.push('div[aria-label="Запомни ме"][role="group"]');
        if (CONFIG.hideOrderSummary) {
          selectors.push('header[data-inspector-id="header"]');
          selectors.push('aside[data-inspector-id="orderSummary"]');
          selectors.push('footer[data-inspector-id="footer"]');
          selectors.push('section[aria-labelledby="mobile-order-summary-heading"]');
        }
        if (CONFIG.hidePaymentIntro) selectors.push('section[aria-label="Плащане"] > [role="group"][aria-labelledby="payment"] > :first-child');
        if (CONFIG.hideContact || CONFIG.hideDelivery) {
          selectors.push('div._1fragemqe._1fragem5u._1fragemws.gfFXW');
          selectors.push('div._1fragem5u._16s97g75u');
        }
        const style = doc.createElement('style');
        style.id = 'aic-hide-prefill-sections';
        style.textContent = selectors.length ? `${selectors.join(',\n')} { display: none !important; }` : '';
        doc.head.appendChild(style);
      }

      const rememberGroup = CONFIG.hideRememberMe ? doc.querySelector('div[aria-label="Запомни ме"][role="group"]') : null;
      const rememberSection = rememberGroup?.closest('section');
      if (CONFIG.hideRememberMe && rememberSection instanceof HTMLElement) {
        rememberSection.style.setProperty('display', 'none', 'important');
      }

      syncCardBillingCheckbox(frame);
      syncCheckoutPaymentAvailability(frame);
      installCheckoutRequirementsGuard(frame);

      const root = doc.documentElement;
      if (root && !frame.__aicPrefillObserver) {
        const observer = new MutationObserver(() => scheduleCheckoutViewport(frame));
        observer.observe(root, { childList: true, subtree: true });
        frame.__aicPrefillObserver = observer;
      }
    } catch (_) {}
  }

  function resizeCheckoutIframeToPayment(frame) {
    try {
      const doc = frame.contentDocument;
      const win = frame.contentWindow;
      const payment = doc?.querySelector('section[aria-label="Плащане"]');
      const payButton = doc?.getElementById('checkout-pay-button');
      if (!payment || !payButton || !win) return;

      const paymentTop = payment.getBoundingClientRect().top + win.scrollY;
      const payBottom = payButton.getBoundingClientRect().bottom + win.scrollY;
      const validationMessage = doc.querySelector('[data-aic-checkout-validation-message]:not([hidden])');
      const validationBottom = validationMessage ? validationMessage.getBoundingClientRect().bottom + win.scrollY : payBottom;
      const contentBottom = Math.max(payBottom, validationBottom);
      const desired = Math.max(360, Math.min(900, Math.ceil(contentBottom - paymentTop + 42)));
      frame.style.height = `${desired}px`;
      frame.style.minHeight = `${desired}px`;
    } catch (_) {}
  }

  function scheduleCheckoutViewport(frame) {
    clearTimeout(frame.__aicViewportTimer);
    frame.__aicViewportTimer = setTimeout(() => {
      applyCheckoutSimplifications(frame);
      if (CONFIG.autoHeightPayment) resizeCheckoutIframeToPayment(frame);
      const instantPayment = !!document.querySelector('.aic-inline-checkout-host-instant');
      if (CONFIG.autoScrollPayment && !instantPayment) scrollCheckoutIframeToPayment(frame);
    }, 80);
  }

  function scrollCheckoutIframeToPayment(frame) {
    const startedAt = Date.now();
    const tryScroll = () => {
      try {
        const doc = frame.contentDocument;
        const win = frame.contentWindow;
        const payment = doc?.querySelector('section[aria-label="Плащане"]');
        if (payment && win) {
          const top = payment.getBoundingClientRect().top + win.scrollY - 18;
          win.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
          return;
        }
      } catch (_) {
        return;
      }
      if (Date.now() - startedAt < 10000) setTimeout(tryScroll, 180);
    };
    tryScroll();
  }

  function showDrawerCheckoutIframe() {
    restoreShippingInline();
    const thread = document.querySelector('[data-aic-thread]');
    if (!thread) throw new Error('Не успяхме да отворим Shopify Checkout.');
    thread.classList.add('is-checkout-frame');
    thread.innerHTML = `<div class="aic-checkout-frame-shell aic-checkout-frame-shell-full"><iframe class="aic-checkout-frame aic-checkout-frame-full" data-aic-checkout-frame src="${ROOT}checkout" title="Shopify Checkout" allow="payment *"></iframe></div>`;
    const frame = thread.querySelector('[data-aic-checkout-frame]');
    frame?.addEventListener('load', () => {
      prefillShopifyCheckout(frame);
      setTimeout(() => prefillShopifyCheckout(frame), 180);
      scheduleCheckoutPaymentSync(frame);
      scheduleCheckoutViewport(frame);
      setTimeout(() => scheduleCheckoutViewport(frame), 350);
      setTimeout(() => scheduleCheckoutViewport(frame), 900);
    }, { once: true });
  }

  function showCheckoutIframe() {
    restoreShippingInline();
    const host = document.querySelector('[data-aic-inline-checkout-host]');
    const frameHost = host?.querySelector('[data-aic-inline-checkout-frame-host]');
    const paymentButton = document.querySelector('[data-aic-payment="card"]');
    if (!host || !frameHost) throw new Error('Не успяхме да отворим Shopify Checkout.');

    host.hidden = false;
    frameHost.innerHTML = `<div class="aic-checkout-frame-shell aic-checkout-frame-shell-inline">
      <iframe class="aic-checkout-frame aic-checkout-frame-inline" data-aic-checkout-frame src="${ROOT}checkout" title="Shopify Checkout" allow="payment *"></iframe>
    </div>`;

    if (paymentButton instanceof HTMLButtonElement) {
      paymentButton.disabled = true;
      paymentButton.innerHTML = 'Плащането е отворено <span>↓</span>';
    }

    const frame = host.querySelector('[data-aic-checkout-frame]');
    frame?.addEventListener('load', () => {
      prefillShopifyCheckout(frame);
      setTimeout(() => prefillShopifyCheckout(frame), 180);
      scheduleCheckoutPaymentSync(frame);
      scheduleCheckoutViewport(frame);
      setTimeout(() => scheduleCheckoutViewport(frame), 350);
      setTimeout(() => scheduleCheckoutViewport(frame), 900);
    }, { once: true });
  }

  function closeCheckoutIframe() {
    const host = document.querySelector('[data-aic-inline-checkout-host]');
    const paymentButton = document.querySelector('[data-aic-payment="card"]');
    if (host) {
      const frameHost = host.querySelector('[data-aic-inline-checkout-frame-host]');
      if (frameHost) frameHost.innerHTML = '';
      host.hidden = true;
    }
    if (paymentButton instanceof HTMLButtonElement) {
      paymentButton.disabled = false;
      paymentButton.innerHTML = `${escapeHtml(CONFIG.checkoutCta)} <span>→</span>`;
    }
    document.documentElement.classList.remove('aic-checkout-handoff');
    busy = false;
  }

  async function handoffToShopifyCheckout(paymentPreference) {
    if (busy) return;
    const form = document.querySelector('[data-aic-details-form]');
    if (form) {
      const data = new FormData(form);
      customerDraft = {
        firstName: String(data.get('first_name') || '').trim(),
        lastName: String(data.get('last_name') || '').trim(),
        phone: String(data.get('phone') || '').trim(),
        email: String(data.get('email') || '').trim()
      };
    }
    if (shippingMethod === 'ADDRESS') {
      const addressValid = await validateCustomShippingAddress();
      if (!addressValid) {
        validateCheckoutRequirements({ showErrors: true, focusFirst: true });
        return;
      }
    }
    if (!validateCheckoutRequirements({ showErrors: true, focusFirst: true })) return;
    if (paymentPreference === 'cod' && !isEcontShipping()) return;

    busy = true;
    document.documentElement.classList.add('aic-checkout-handoff');
    document.querySelectorAll('[data-aic-payment]').forEach((button) => { button.disabled = true; });
    try {
      await persistCheckoutContext({ '__aic_payment_preference': paymentPreference });
      if (paymentPreference === 'card') {
        if (CONFIG.checkoutMode === 'normal') {
          window.location.assign(`${ROOT}checkout`);
          return;
        }
        if (CONFIG.checkoutMode === 'embedded_drawer') {
          showDrawerCheckoutIframe();
          busy = false;
          return;
        }
        showCheckoutIframe();
        busy = false;
        return;
      }
      window.location.assign(`${ROOT}checkout`);
    } catch (error) {
      document.documentElement.classList.remove('aic-checkout-handoff');
      busy = false;
      render(error instanceof Error ? error.message : 'Не успяхме да продължим към плащането.');
    }
  }

  function render(errorMessage) {
    ensureShell();
    const thread = document.querySelector('[data-aic-thread]');
    if (!thread) return;

    if (!cart) {
      thread.innerHTML = `<div class="aic-loading">Зареждам продуктите ви…</div>`;
      return;
    }
    if (!cart.items?.length) {
      step = 'cart';
      upsellDecision = null;
      thread.innerHTML = `<section class="aic-turn aic-flow-section"><div class="aic-flow-copy"><strong>Количката ви е празна.</strong><span>Добавете продукт, за да продължите.</span></div></section>`;
      return;
    }

    const flow = step === 'upsell'
      ? upsellTurn()
      : step === 'details'
        ? detailsTurn()
        : `${detailsSentTurn()}${paymentTurn()}`;
    thread.innerHTML = `${errorMessage ? `<div class="aic-error">${escapeHtml(errorMessage)}</div>` : ''}
      ${userCartMessage()}
      ${flow}`;

    if (step === 'details') {
      queueMicrotask(() => {
        const pinDetailsStart = shouldPinDetailsStart;
        if (pinDetailsStart) queueDetailsStartScroll();
        void ensureShippingInlineMounted().finally(() => {
          if (!pinDetailsStart || step !== 'details') return;
          shouldPinDetailsStart = false;
          queueDetailsStartScroll();
        });
        syncInlinePaymentOptions();
      });
    } else if (step === 'payment') {
      queueMicrotask(() => {
        const frame = document.querySelector('[data-aic-checkout-frame]');
        if (frame) scheduleCheckoutPaymentSync(frame);
      });
    }
  }

  async function refreshCart() {
    cart = await cartRequest('.js');
    await enrichCartCompareAtPrices();
    syncThemeCount();
    render();
    syncDemoNotice();
    return cart;
  }

  async function openDrawer(trigger) {
    discountFeedback = null;
    step = 'cart';
    upsellDecision = null;
    upsellAddedKeys.clear();
    upsellSelectedKeys.clear();
    upsellSelectionInitialized = false;
    upsellInitialCartProductIds.clear();
    upsellInitialCartVariantIds.clear();
    shouldPinDetailsStart = false;
    lastTrigger = trigger || (document.activeElement instanceof HTMLElement ? document.activeElement : null);
    suppressNativeDrawer();
    ensureShell();
    document.querySelector('[data-aic-drawer]')?.classList.add('is-open');
    document.querySelector('[data-aic-backdrop]')?.classList.add('is-open');
    document.querySelector('[data-aic-drawer]')?.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('aic-lock');
    try { await refreshCart(); }
    catch (error) { render(error instanceof Error ? error.message : 'Не успяхме да заредим количката.'); }
    suppressNativeDrawer();
  }

  function closeDrawer() {
    restoreShippingInline();
    document.querySelector('[data-aic-drawer]')?.classList.remove('is-open');
    document.querySelector('[data-aic-backdrop]')?.classList.remove('is-open');
    document.querySelector('[data-aic-drawer]')?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aic-lock');
    suppressNativeDrawer();
    step = 'cart';
    upsellDecision = null;
    upsellAddedKeys.clear();
    upsellSelectedKeys.clear();
    upsellSelectionInitialized = false;
    upsellInitialCartProductIds.clear();
    upsellInitialCartVariantIds.clear();
    shouldPinDetailsStart = false;
    lastTrigger?.focus?.();
  }

  async function addFromThemeForm(form, submitter) {
    if (busy) return;
    busy = true;
    const button = submitter instanceof HTMLButtonElement ? submitter : form.querySelector('button[type="submit"],input[type="submit"]');
    if (button) button.disabled = true;
    try {
      const formData = new FormData(form);
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: formData
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'Не успяхме да добавим продукта.');
      measureOpenAiItemsAdded(openAiItemsForAdd(payload, openAiRequestedItems(formData)));
      step = 'cart';
      upsellDecision = null;
      await openDrawer(button instanceof HTMLElement ? button : null);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не успяхме да добавим продукта.';
      if (window.theme?.alert?.new) window.theme.alert.new('', message, 3000, 'warning');
      else window.alert(message);
    } finally {
      busy = false;
      if (button) button.disabled = false;
      render();
    }
  }

  function enterDetailsStep() {
    step = 'details';
    shouldPinDetailsStart = true;
    render();
    queueDetailsStartScroll();
  }

  function continueFromUpsell() {
    enterDetailsStep();
  }

  async function addUpsellsToCart(upsells, options = {}) {
    if (busy || step !== 'upsell') return;
    const itemsToAdd = Array.isArray(upsells) ? upsells.filter(Boolean) : [];
    if (!itemsToAdd.length) return;
    const advanceAfterAdd = options.advanceAfterAdd === true;

    busy = true;
    render();
    let errorMessage = '';
    try {
      const addedPayload = await cartRequest('/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: itemsToAdd.map((upsell) => ({
            id: upsell.variantId,
            quantity: 1,
            properties: {
              '__aic_upsell': 'true',
              '__aic_upsell_key': String(upsell.key)
            }
          }))
        })
      });
      const addedItems = openAiItemsForAdd(addedPayload, itemsToAdd.map((upsell) => ({ id: upsell.variantId, quantity: 1 })));
      measureOpenAiItemsAdded(addedItems);
      measureOpenAiUpsellItemAdded(addedItems);
      itemsToAdd.forEach((upsell) => upsellAddedKeys.add(upsell.key));
      cart = await cartRequest('.js');
      await enrichCartCompareAtPrices();
      syncThemeCount();
      upsellDecision = 'added';
      render();
      for (const upsell of itemsToAdd) await applyUpsellDiscountCode(upsell);
    } catch (error) {
      errorMessage = error instanceof Error ? error.message : 'Не успяхме да добавим избраните продукти.';
    } finally {
      busy = false;
      const remainingUpsells = getUpsellProducts().filter((upsell) => !upsell.added);
      if (!errorMessage && (advanceAfterAdd || remainingUpsells.length === 0)) {
        continueFromUpsell();
      } else {
        render(errorMessage);
        if (!errorMessage) queueAicThreadScroll('.aic-upsell-step');
      }
    }
  }

  async function addUpsellToCart(upsellKey) {
    if (busy || step !== 'upsell') return;
    const upsell = getUpsellProduct(upsellKey);
    if (!upsell) {
      if (!getUpsellProducts().length) continueFromUpsell();
      return;
    }
    await addUpsellsToCart([upsell]);
  }

  async function addSelectedUpsellsToCart() {
    if (busy || step !== 'upsell') return;
    const selectedUpsells = getUpsellProducts().filter((upsell) => (
      !upsell.added && upsellSelectedKeys.has(upsell.key)
    ));
    await addUpsellsToCart(selectedUpsells, { advanceAfterAdd: true });
  }

  async function changeLine(key, quantity) {
    if (busy) return;
    const previousItem = cart?.items?.find((item) => item.key === key);
    const previousQuantity = Number(previousItem?.quantity) || 0;
    busy = true;
    render();
    try {
      cart = await cartRequest('/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
      });
      const updatedItem = cart?.items?.find((item) => item.key === key);
      const addedQuantity = Math.max(0, (Number(updatedItem?.quantity) || 0) - previousQuantity);
      if (addedQuantity > 0 && updatedItem) {
        measureOpenAiItemsAdded([{ ...updatedItem, quantity: addedQuantity }]);
      }
      await enrichCartCompareAtPrices();
      syncThemeCount();
      render();
    } catch (error) {
      render(error instanceof Error ? error.message : 'Не успяхме да обновим количката.');
    } finally {
      busy = false;
      suppressNativeDrawer();
      render();
    }
  }

  function getCartCookieId() {
    try {
      const raw = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith('cart='));
      if (!raw) return null;
      return decodeURIComponent(raw.slice(5)).split('?')[0] || null;
    } catch (_) {
      return null;
    }
  }

  function getCookieValue(name) {
    try {
      const prefix = `${name}=`;
      const entry = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
      return entry ? entry.slice(prefix.length) : '';
    } catch (_) {
      return '';
    }
  }

  function openAiAttributionCartAttributes() {
    const attributes = { openai_oppref: '', openai_obref: '' };
    if (!openAiMeasurementAllowed()) return attributes;
    const oppref = getCookieValue('__oppref');
    const obref = getCookieValue('__obref');
    if (oppref) attributes.openai_oppref = oppref;
    if (obref) attributes.openai_obref = obref;
    return attributes;
  }

  function readPersistedShippingSelection() {
    const cartId = getCartCookieId();
    if (!cartId) return null;
    try {
      const raw = sessionStorage.getItem(`crystal-shipping-selection:${cartId}`);
      if (!raw) return null;
      const value = JSON.parse(raw);
      if (!value?.selection || typeof value.selection.method !== 'string' || typeof value.selection.handle !== 'string') return null;
      return value;
    } catch (_) {
      return null;
    }
  }

  function clearPersistedShippingSelection() {
    const cartId = getCartCookieId();
    if (!cartId) return;
    try { sessionStorage.removeItem(`crystal-shipping-selection:${cartId}`); } catch (_) {}
  }

  function persistCurrentShippingSelection() {
    const cartId = getCartCookieId();
    if (!cartId || !shippingSelection) return;
    try {
      sessionStorage.setItem(`crystal-shipping-selection:${cartId}`, JSON.stringify({
        selection: shippingSelection,
        addressDraft: shippingAddressDraft,
        addressStatus: shippingAddressStatus,
      }));
    } catch (_) {}
  }

  function refreshOpenCheckoutAfterShippingChange({ scrollTargetSelector = '' } = {}) {
    const frame = document.querySelector('[data-aic-checkout-frame]');
    if (!frame) {
      if (scrollTargetSelector) queueAicThreadScroll(scrollTargetSelector);
      return;
    }
    saveCustomerDraftFromForm();
    const thread = document.querySelector('[data-aic-thread]');
    const scrollTop = thread?.scrollTop ?? 0;
    frame.addEventListener('load', () => {
      prefillShopifyCheckout(frame);
      setTimeout(() => prefillShopifyCheckout(frame), 180);
      scheduleCheckoutShippingSync(frame);
      scheduleCheckoutPaymentSync(frame);
      scheduleCheckoutViewport(frame);
      setTimeout(() => scheduleCheckoutViewport(frame), 350);
      setTimeout(() => scheduleCheckoutViewport(frame), 900);
      requestAnimationFrame(() => {
        if (scrollTargetSelector) queueAicThreadScroll(scrollTargetSelector);
        else if (thread?.isConnected) thread.scrollTop = scrollTop;
      });
    }, { once: true });
    try { frame.src = `${ROOT}checkout`; } catch (_) {}
  }

  function saveCustomerDraftFromForm() {
    const form = document.querySelector('[data-aic-details-form]');
    if (!form) return;
    const data = new FormData(form);
    customerDraft = {
      firstName: String(data.get('first_name') || '').trim(),
      lastName: String(data.get('last_name') || '').trim(),
      phone: String(data.get('phone') || '').trim(),
      email: String(data.get('email') || '').trim()
    };
  }

  function formatShippingPrice(option) {
    const cost = option?.estimatedCost;
    if (!cost) return '';
    const amount = Number(cost.amount || 0);
    if (amount === 0) return 'Безплатно';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'bg-BG', {
        style: 'currency', currency: cost.currencyCode || cart?.currency || 'EUR'
      }).format(amount);
    } catch (_) {
      return `${cost.currencyCode || 'EUR'} ${amount.toFixed(2)}`;
    }
  }

  function shippingMethodLabel(method) {
    return window.CrystalShipping?.methods?.[method]?.label || method;
  }

  function shippingOptionForMethod(method = shippingMethod) {
    const engine = window.CrystalShipping;
    const definition = engine?.methods?.[method];
    const rate = engine?.findRateForMethod?.(method, shippingRates);
    if (!definition || !rate) return null;
    return {
      handle: rate.code || rate.name,
      courierName: definition.courierName,
      displayName: rate.name,
      title: rate.name,
      name: rate.name,
      rateName: rate.name,
      estimatedCost: { amount: rate.amount, currencyCode: rate.currencyCode || cart?.currency || 'EUR' },
      rate,
    };
  }

  function shippingOptionKey(option = shippingOption) {
    return option ? `${shippingMethod}::${option.handle || ''}` : shippingMethod;
  }

  function currentShippingSearchDraft(option = shippingOption) {
    return shippingSearchDrafts.get(shippingOptionKey(option)) || '';
  }

  function pickupResultsHtml() {
    if (!shippingSearchResults.length) return '';
    return shippingSearchResults.map((location, index) => {
      const prefix = location.id ? `[${location.id}] ` : '';
      const address = [location.address1, location.city, location.postalCode].filter(Boolean).join(', ');
      return `<button type="button" class="aic-ship-result" data-aic-pickup-index="${index}"><strong>${escapeHtml(prefix + location.name)}</strong><span>${escapeHtml(address)}</span>${location.note ? `<small>${escapeHtml(location.note)}</small>` : ''}</button>`;
    }).join('');
  }

  function pickupSearchHtml(option = shippingOption) {
    const value = currentShippingSearchDraft(option);
    return `<div class="aic-ship-search-wrap">
      <input type="search" data-aic-ship-search name="aic_office_lookup" value="${escapeHtml(value)}" placeholder="Напиши град, офис или адрес" aria-label="Търси град, офис или адрес" autocomplete="off" enterkeyhint="search" autocapitalize="off" spellcheck="false" data-form-type="other" data-lpignore="true" data-1p-ignore="true">
      <div class="aic-ship-results" data-aic-ship-results>${pickupResultsHtml()}</div>
    </div>`;
  }

  function cityResultsHtml() {
    return shippingCityResults.map((city, index) => `<button type="button" class="aic-ship-result" data-aic-city-index="${index}"><strong>${escapeHtml(city.name)}</strong><span>${escapeHtml([city.regionName, city.postCode].filter(Boolean).join(' · '))}</span></button>`).join('');
  }

  function addressStatusHtml() {
    const state = shippingAddressStatus.state;
    const labels = { checking: 'Проверяваме адреса с Еконт…', valid: 'Еконт потвърди доставката до този адрес.', invalid: shippingAddressStatus.message || 'Еконт не потвърди адреса.' };
    return `<div class="aic-address-status is-${escapeHtml(state)}" data-aic-address-status role="status">${escapeHtml(shippingAddressStatus.message || labels[state] || '')}</div>`;
  }

  function shippingProviderLogoHtml(method) {
    const providerLogo = method === 'BOX'
      ? window.CrystalShippingAssets?.boxNowLogo
      : window.CrystalShippingAssets?.econtLogo;
    if (providerLogo) {
      return `<img src="${escapeHtml(providerLogo)}" alt="${method === 'BOX' ? 'BOX NOW' : 'Еконт'}" width="40" height="40">`;
    }
    return `<span class="aic-provider-mark is-${method.toLowerCase()}">${method === 'BOX' ? 'B' : 'E'}</span>`;
  }

  function shippingFallbackTitle(method) {
    if (method === 'BOX') return 'BOX NOW автомат (само с картово плащане)';
    if (method === 'ADDRESS') return 'До адрес с Еконт';
    return 'До офис с Еконт';
  }

  function shippingOptionHtml(method, option, isActive, selectMethod = false) {
    const targetAttributes = selectMethod
      ? `data-aic-ship-method="${escapeHtml(method)}"`
      : `data-aic-ship-option="${escapeHtml(option?.handle || '')}" data-aic-ship-courier="${escapeHtml(option?.courierName || '')}"`;
    const unavailable = !option;
    return `<button type="button" class="aic-ship-option${isActive ? ' is-active' : ''}${unavailable ? ' is-unavailable' : ''}" ${unavailable ? 'disabled aria-disabled="true"' : targetAttributes}>
      <span class="aic-ship-logo">${shippingProviderLogoHtml(method)}</span>
      <span class="aic-ship-copy"><strong>${escapeHtml(option?.displayName || shippingFallbackTitle(method))}</strong><small>${escapeHtml(option?.courierName || (method === 'BOX' ? 'BOX NOW' : 'Еконт'))}</small></span>
      <span class="aic-ship-price">${unavailable ? 'Неналично' : escapeHtml(formatShippingPrice(option))}</span>
    </button>`;
  }

  function activeShippingDetailHtml() {
    if (shippingMethod === 'ADDRESS') {
      if (shippingSelection?.method === 'ADDRESS' && shippingAddressStatus.state === 'valid' && !shippingEditing) {
        return `<div class="aic-ship-selected"><strong>${escapeHtml(shippingSelection.location || '')}</strong><span>${escapeHtml(shippingSelection.address || '')}</span></div>
          <button type="button" class="aic-ship-change" data-aic-change-shipping>Промяна</button>`;
      }
      return `<div class="aic-ship-address">
        <div class="aic-ship-search-wrap aic-city-search-wrap">
          <input data-aic-ship-city-search value="${escapeHtml(shippingAddressDraft.city)}" placeholder="Населено място" autocomplete="off" spellcheck="false">
          <div class="aic-ship-results" data-aic-city-results>${cityResultsHtml()}</div>
        </div>
        <input data-aic-ship-address="zip" value="${escapeHtml(shippingAddressDraft.zip)}" placeholder="Пощенски код" autocomplete="shipping postal-code" readonly>
        <input data-aic-ship-address="address1" value="${escapeHtml(shippingAddressDraft.address1)}" placeholder="Улица и номер или квартал, блок и вход" autocomplete="shipping address-line1" ${shippingAddressDraft.cityRecord ? '' : 'disabled'}>
        ${addressStatusHtml()}
      </div>`;
    }
    if (!shippingOption) return '';
    const selected = shippingSelection?.pickupPoint || null;
    if (selected && !shippingEditing) {
      return `<div class="aic-ship-selected"><strong>${escapeHtml(shippingSelection.location || '')}</strong><span>${escapeHtml(shippingSelection.address || '')}</span></div>
        <button type="button" class="aic-ship-change" data-aic-change-shipping>Промяна</button>`;
    }
    return pickupSearchHtml(shippingOption);
  }

  function renderCustomShipping() {
    const host = document.querySelector('[data-aic-shipping-inline]');
    if (!host || !window.CrystalShipping) return;
    const tabMethods = ['OFFICE', 'BOX', 'ADDRESS'];
    const stackedMethods = ['BOX', 'OFFICE', 'ADDRESS'];
    if (!tabMethods.includes(shippingMethod)) shippingMethod = 'OFFICE';
    shippingOption = shippingOptionForMethod(shippingMethod);
    const detailHtml = activeShippingDetailHtml();
    const useStackedLayout = CONFIG.deliverySearchLayout === 'under_selected';
    let shippingHtml = '';
    if (useStackedLayout) {
      const optionsHtml = stackedMethods.map((method) => {
        const option = shippingOptionForMethod(method);
        const isActive = method === shippingMethod;
        return `<div class="aic-ship-option-slot${isActive ? ' is-active' : ''}">
          ${shippingOptionHtml(method, option, isActive, true)}
          ${isActive ? detailHtml : ''}
        </div>`;
      }).join('');
      shippingHtml = `<div class="aic-ship-options aic-ship-options-stacked">${optionsHtml}</div>`;
    } else {
      const methodsHtml = tabMethods.map((method) => `<button type="button" class="aic-ship-tab${method === shippingMethod ? ' is-active' : ''}" data-aic-ship-method="${escapeHtml(method)}">${escapeHtml(shippingMethodLabel(method))}</button>`).join('');
      const optionHtml = shippingOption
        ? `<div class="aic-ship-option-slot is-active">${shippingOptionHtml(shippingMethod, shippingOption, true)}</div>`
        : '<div class="aic-ship-empty">Този Shopify shipping rate не е наличен за количката.</div>';
      shippingHtml = `<div class="aic-ship-tabs">${methodsHtml}</div><div class="aic-ship-options">${optionHtml}</div>${detailHtml}`;
    }

    host.className = `aic-shipping-inline aic-custom-shipping is-${useStackedLayout ? 'stacked' : 'tabs'}${CONFIG.emphasizeSelectedDelivery && shippingSelection && !shippingEditing ? ' has-selection' : ''}`;
    host.innerHTML = shippingHtml;
    const addressInput = host.querySelector('[data-aic-ship-address="address1"]');
    addressInput?.addEventListener('input', () => updateShippingAddressDraft(addressInput.value));
    document.querySelector('[data-aic-shipping-loading]')?.remove();
    syncInlinePaymentOptions();
  }

  function syncCustomShippingDoneState() {
    if (shippingMethod === 'ADDRESS' && shippingAddressStatus.state !== 'valid' && shippingSelection?.method === 'ADDRESS') shippingSelection = null;
    syncInlinePaymentOptions();
  }

  async function bootCustomShipping() {
    const host = document.querySelector('[data-aic-shipping-inline]');
    const loading = document.querySelector('[data-aic-shipping-loading]');
    if (!host || step !== 'details') return;
    saveCustomerDraftFromForm();
    try {
      if (!window.CrystalShipping) throw new Error('Crystal Shipping модулът не е наличен.');
      if (!shippingRates.length) shippingRates = await window.CrystalShipping.getShopifyRates();
      const persisted = readPersistedShippingSelection();
      if (!shippingSelection && persisted?.selection) {
        shippingSelection = persisted.selection;
        shippingMethod = persisted.selection.method;
        if (persisted.addressDraft) shippingAddressDraft = persisted.addressDraft;
        if (persisted.addressStatus) shippingAddressStatus = persisted.addressStatus;
        shippingEditing = false;
      }
      shippingOption = shippingOptionForMethod(shippingMethod);
      renderCustomShipping();
      resyncOpenCheckoutPayment();
    } catch (error) {
      if (loading) loading.textContent = error instanceof Error ? error.message : 'Не успяхме да заредим доставката.';
    }
  }

  async function selectCustomShippingMethod(method) {
    if (!window.CrystalShipping?.methods?.[method]) return;
    shippingMethod = method;
    shippingOption = shippingOptionForMethod(method);
    clearPersistedShippingSelection();
    void queueShippingCartAttributes(null);
    shippingSelection = null;
    shippingEditing = true;
    shippingSearchResults = [];
    shippingCityResults = [];
    shippingAddressStatus = { state: 'idle', message: '' };
    renderCustomShipping();
    resyncOpenCheckoutPayment();
    validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
    refreshOpenCheckoutAfterShippingChange({ scrollTargetSelector: '[data-aic-inline-payment] .aic-payment-intro' });
  }

  async function selectCustomShippingOption(handle, courierName) {
    const option = shippingOptionForMethod(shippingMethod);
    if (!option || option.handle !== handle || option.courierName !== courierName) return;
    shippingOption = option;
    clearPersistedShippingSelection();
    void queueShippingCartAttributes(null);
    shippingSelection = null;
    shippingEditing = true;
    renderCustomShipping();
    resyncOpenCheckoutPayment();
    validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
    refreshOpenCheckoutAfterShippingChange({ scrollTargetSelector: '[data-aic-inline-payment] .aic-payment-intro' });
    const savedQuery = currentShippingSearchDraft(option);
    if (savedQuery.trim().length >= 2) {
      setTimeout(() => { void searchCustomPickupPoints(savedQuery); }, 0);
    }
  }

  async function searchCustomPickupPoints(query) {
    if (!window.CrystalShipping || !shippingOption || shippingMethod === 'ADDRESS') return;
    const seq = ++shippingSearchSeq;
    const results = document.querySelector('[data-aic-ship-results]');
    if (!results) return;
    const term = query.trim();
    if (term.length < 2) { shippingSearchResults = []; results.innerHTML = ''; return; }
    results.innerHTML = '<div class="aic-ship-searching">Търся…</div>';
    try {
      const points = shippingMethod === 'BOX'
        ? await window.CrystalShipping.searchBoxNowLocations(term)
        : await window.CrystalShipping.searchEcontOffices(term);
      if (seq !== shippingSearchSeq) return;
      shippingSearchResults = points;
      results.innerHTML = points.length ? pickupResultsHtml() : '<div class="aic-ship-empty">Няма намерени места за доставка.</div>';
    } catch (_) {
      if (seq === shippingSearchSeq) results.innerHTML = '<div class="aic-ship-empty">Не успяхме да заредим местата за доставка.</div>';
    }
  }

  async function selectCustomPickupPoint(index) {
    const location = shippingSearchResults[index];
    if (!location || !shippingOption || !window.CrystalShipping) return;
    const point = window.CrystalShipping.pickupPointShape(location);
    const details = point.details || {};
    const address = point.address || {};
    const prefix = details.locationOfficeId && String(details.locationOfficeId).trim() !== '0' ? `[${details.locationOfficeId}] ` : '';
    shippingSelection = {
      method: shippingMethod,
      handle: shippingOption.handle,
      rateName: shippingOption.rateName,
      courierName: shippingOption.courierName,
      location: `${prefix}${details.name || shippingOption.courierName}`,
      address: [address.address1, address.city].filter(Boolean).join(', '),
      pickupPoint: point,
      option: shippingOption
    };
    shippingEditing = false;
    persistCurrentShippingSelection();
    renderCustomShipping();
    void queueShippingCartAttributes();
    syncInlinePaymentOptions();
    syncLiveCheckoutPrefill();
    validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
    refreshOpenCheckoutAfterShippingChange({ scrollTargetSelector: '[data-aic-inline-payment] .aic-payment-intro' });
  }

  async function searchShippingCities(query) {
    const results = document.querySelector('[data-aic-city-results]');
    const term = String(query || '').trim();
    if (!results) return;
    if (term.length < 2) { shippingCityResults = []; results.innerHTML = ''; return; }
    results.innerHTML = '<div class="aic-ship-searching">Търся населено място…</div>';
    try {
      shippingCityResults = await window.CrystalShipping.searchCities(term);
      results.innerHTML = shippingCityResults.length ? cityResultsHtml() : '<div class="aic-ship-empty">Няма намерено населено място.</div>';
    } catch (_) {
      results.innerHTML = '<div class="aic-ship-empty">Не успяхме да заредим населените места.</div>';
    }
  }

  function selectShippingCity(index) {
    const city = shippingCityResults[index];
    if (!city) return;
    shippingAddressDraft = { city: city.name || '', zip: city.postCode || '', address1: '', cityRecord: city };
    shippingCityResults = [];
    shippingAddressStatus = { state: 'idle', message: '' };
    shippingSelection = null;
    shippingEditing = true;
    clearPersistedShippingSelection();
    renderCustomShipping();
    requestAnimationFrame(() => document.querySelector('[data-aic-ship-address="address1"]')?.focus());
  }

  function updateAddressStatusDom() {
    const node = document.querySelector('[data-aic-address-status]');
    if (!node) return;
    node.className = `aic-address-status is-${shippingAddressStatus.state}`;
    node.textContent = shippingAddressStatus.message || (shippingAddressStatus.state === 'checking' ? 'Проверяваме адреса с Еконт…' : '');
  }

  function updateShippingAddressDraft(value) {
    shippingAddressDraft.address1 = String(value || '');
    shippingSelection = null;
    shippingEditing = true;
    shippingAddressStatus = { state: 'idle', message: '' };
    clearPersistedShippingSelection();
    if (shippingAddressTimer) clearTimeout(shippingAddressTimer);
    if (shippingAddressDraft.cityRecord && shippingAddressDraft.address1.trim().length >= 3) {
      shippingAddressTimer = setTimeout(() => { void validateCustomShippingAddress(); }, 650);
    }
    updateAddressStatusDom();
    syncCustomShippingDoneState();
    validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
  }

  async function validateCustomShippingAddress() {
    if (shippingMethod !== 'ADDRESS' || !shippingAddressDraft.cityRecord || shippingAddressDraft.address1.trim().length < 3) return false;
    const seq = ++shippingAddressSeq;
    shippingSelection = null;
    shippingAddressStatus = { state: 'checking', message: 'Проверяваме адреса с Еконт…' };
    updateAddressStatusDom();
    syncInlinePaymentOptions();
    validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
    try {
      const result = await window.CrystalShipping.validateEcontAddress({
        city: shippingAddressDraft.cityRecord,
        address1: shippingAddressDraft.address1,
        customer: customerDraft,
        cart,
      });
      if (seq !== shippingAddressSeq) return false;
      shippingOption = shippingOptionForMethod('ADDRESS');
      if (!shippingOption) throw new Error('Доставката до адрес не е активна за количката.');
      shippingAddressStatus = { state: 'valid', message: result.warning || 'Еконт потвърди доставката до този адрес.' };
      shippingSelection = {
        method: 'ADDRESS',
        handle: shippingOption.handle,
        rateName: shippingOption.rateName,
        courierName: shippingOption.courierName,
        location: shippingOption.displayName,
        address: [result.normalizedAddress || shippingAddressDraft.address1, shippingAddressDraft.city, shippingAddressDraft.zip].filter(Boolean).join(', '),
        normalizedAddress: result.normalizedAddress || shippingAddressDraft.address1,
        cityId: shippingAddressDraft.cityRecord.id,
        pickupPoint: null,
        option: shippingOption,
      };
      shippingEditing = false;
      persistCurrentShippingSelection();
      renderCustomShipping();
      void queueShippingCartAttributes();
      syncLiveCheckoutPrefill();
      refreshOpenCheckoutAfterShippingChange({ scrollTargetSelector: '[data-aic-inline-payment] .aic-payment-intro' });
      return true;
    } catch (error) {
      if (seq !== shippingAddressSeq) return false;
      shippingAddressStatus = { state: 'invalid', message: error instanceof Error ? error.message : 'Еконт не потвърди адреса.' };
      shippingSelection = null;
      updateAddressStatusDom();
      syncInlinePaymentOptions();
      validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
      return false;
    }
  }

  function restoreShippingInline() {
    if (shippingSearchTimer) clearTimeout(shippingSearchTimer);
    if (shippingAddressTimer) clearTimeout(shippingAddressTimer);
  }

  async function ensureShippingInlineMounted() {
    await bootCustomShipping();
  }

  const DEMO_NOTE = '[EASY CHECKOUT DEMO — DO NOT FULFILL]';
  function syncDemoNotice() {
    const drawer = document.querySelector('[data-aic-drawer]');
    if (!drawer) return;
    drawer.querySelector('[data-aic-demo-notice]')?.remove();
    if (cart?.attributes?.easy_checkout_demo !== 'true') return;
    const notice = document.createElement('div');
    notice.setAttribute('data-aic-demo-notice', '');
    notice.style.cssText = 'padding:10px 18px;background:#fff1df;color:#553600;font:13px/1.45 system-ui,sans-serif;flex-shrink:0;';
    const copy = document.createElement('div');
    copy.textContent = 'DEMO — DO NOT FULFILL. This whole cart is marked for demo review. Do not submit payment. ДЕМО — ДА НЕ СЕ ИЗПЪЛНЯВА.';
    const exit = document.createElement('button');
    exit.type = 'button';
    exit.textContent = 'Exit demo / Изход от демото';
    exit.style.cssText = 'background:transparent;border:0;text-decoration:underline;padding:6px 0;color:inherit;font:inherit;cursor:pointer;';
    exit.addEventListener('click', async () => {
      exit.disabled = true;
      try {
        const current = await cartRequest('.js');
        const attributes = Object.fromEntries(['easy_checkout_demo', 'easy_checkout_source', 'easy_checkout_demo_id', 'easy_checkout_demo_started_at', 'fulfillment_instruction'].map(key => [key, '']));
        await cartRequest('/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes, note: String(current.note || '').split('\n').filter(line => line !== DEMO_NOTE).join('\n') }) });
        const url = new URL(window.location.href);
        url.searchParams.delete('easy_checkout_demo');
        window.history.replaceState(null, '', url);
        CONFIG = demoCheckoutConfig(readBuilderConfig());
        await refreshCart();
        closeDrawer();
      } catch (_) { exit.disabled = false; copy.textContent = 'Could not exit demo. The cart is still marked DO NOT FULFILL. Please try again.'; }
    });
    notice.append(copy, exit);
    drawer.querySelector('.aic-header')?.after(notice);
  }

  // Opt-in entry for the App Store demo. Normal storefront visits are unchanged.
  async function openProductDemo() {
    if (window.Shopify?.designMode || !['black-tourmaline', 'citrine'].includes(new URLSearchParams(window.location.search).get('easy_checkout_demo'))) return;
    const variantId = 46834424283467;
    ensureShell();
    const drawer = document.querySelector('[data-aic-drawer]');
    if (!drawer || drawer.querySelector('[data-aic-demo-notice]')) return;
    const notice = document.createElement('div');
    notice.setAttribute('data-aic-demo-notice', '');
    notice.setAttribute('role', 'status');
    notice.style.cssText = 'padding:10px 18px;background:#f4f0fb;color:#40334f;font:13px/1.45 system-ui,sans-serif;flex-shrink:0;';
    notice.textContent = 'Preparing demo tracking…';
    drawer.querySelector('.aic-header')?.after(notice);
    busy = true;
    try {
      const existing = await cartRequest('.js');
      const note = String(existing.note || '');
      const marked = await cartRequest('/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            easy_checkout_demo: 'true', easy_checkout_source: 'crystalenergy_demo_page',
            easy_checkout_demo_id: existing.attributes?.easy_checkout_demo_id || crypto.randomUUID(),
            easy_checkout_demo_started_at: existing.attributes?.easy_checkout_demo_started_at || new Date().toISOString(),
            fulfillment_instruction: 'DEMO — DO NOT FULFILL'
          },
          note: note.split('\n').includes(DEMO_NOTE) ? note : [DEMO_NOTE, note].filter(Boolean).join('\n')
        })
      });
      if (marked.attributes?.easy_checkout_demo !== 'true' || marked.attributes?.fulfillment_instruction !== 'DEMO — DO NOT FULFILL') throw new Error('Demo tracking was not saved');
      // Preserve all existing products and quantities; reopening never adds a duplicate.
      if (!existing.items.some((item) => Number(item.variant_id) === variantId && item.quantity > 0)) {
        await cartRequest('/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      }
      busy = false;
      await openDrawer(null);
    } catch (_) {
      busy = false;
      notice.remove();
      window.alert('The demo could not be prepared safely. Please reload and try again. Do not complete an order.');
    }
  }

  function installHooks() {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    }
    let editorSectionSelected = false;

  function refreshConfigFromSection(scope = document) {
    CONFIG = demoCheckoutConfig(readBuilderConfig(scope));
    if (step === 'upsell' && !getUpsellProducts().length) {
      step = 'cart';
      upsellDecision = null;
    }
    applyBuilderPresentation();
    if (cart) render();
  }

  document.addEventListener('shopify:section:select', (event) => {
    const sectionRoot = event.target?.querySelector?.(`#${DRAWER_ID}`);
    if (!sectionRoot) return;
    editorSectionSelected = true;
    refreshConfigFromSection(event.target);
    void openDrawer(null);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const sectionRoot = event.target?.querySelector?.(`#${DRAWER_ID}`);
    if (!sectionRoot) return;
    editorSectionSelected = false;
  });

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target?.querySelector?.(`#${DRAWER_ID}`);
    if (!sectionRoot) return;
    refreshConfigFromSection(event.target);
    if (editorSectionSelected) void openDrawer(null);
  });

  ensureShell();
  void openProductDemo();

    document.addEventListener('submit', (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form) return;

      if (form.matches('[data-aic-details-form]')) {
        event.preventDefault();
        if (CONFIG.paymentOptionsDisplay === 'after_button') void completeDetails(form);
        return;
      }

      if (!(form.getAttribute('action') || '').includes('/cart/add')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      void addFromThemeForm(form, event.submitter instanceof HTMLElement ? event.submitter : null);
    }, true);

    document.addEventListener('pointerdown', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const method = target?.closest('[data-aic-ship-method]');
      if (method) {
        event.preventDefault();
        event.stopPropagation();
        void selectCustomShippingMethod(method.getAttribute('data-aic-ship-method'));
        return;
      }
      const city = target?.closest('[data-aic-city-index]');
      if (!city) return;
      event.preventDefault();
      event.stopPropagation();
      selectShippingCity(Number(city.getAttribute('data-aic-city-index')));
    }, true);

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const changeShipping = target.closest('[data-aic-change-shipping]');
      if (changeShipping) {
        event.preventDefault();
        clearPersistedShippingSelection();
        void queueShippingCartAttributes(null);
        shippingSelection = null;
        shippingEditing = true;
        if (shippingMethod === 'ADDRESS') shippingAddressStatus = { state: 'idle', message: '' };
        renderCustomShipping();
        requestAnimationFrame(() => (document.querySelector('[data-aic-ship-search]') || document.querySelector('[data-aic-ship-address="address1"]'))?.focus());
        return;
      }

      const shipMethod = target.closest('[data-aic-ship-method]');
      if (shipMethod) {
        event.preventDefault();
        void selectCustomShippingMethod(shipMethod.getAttribute('data-aic-ship-method'));
        return;
      }

      const shipOption = target.closest('[data-aic-ship-option]');
      if (shipOption) {
        event.preventDefault();
        void selectCustomShippingOption(shipOption.getAttribute('data-aic-ship-option'), shipOption.getAttribute('data-aic-ship-courier'));
        return;
      }

      const pickup = target.closest('[data-aic-pickup-index]');
      if (pickup) {
        event.preventDefault();
        void selectCustomPickupPoint(Number(pickup.getAttribute('data-aic-pickup-index')));
        return;
      }

      const city = target.closest('[data-aic-city-index]');
      if (city) {
        event.preventDefault();
        selectShippingCity(Number(city.getAttribute('data-aic-city-index')));
        return;
      }

      const linkedButtonTrigger = target.closest('#js-sticky-btn, [data-buttonid]');
      const linkedButtonId = linkedButtonTrigger?.getAttribute('data-buttonid');
      const linkedButton = linkedButtonId ? document.getElementById(linkedButtonId) : null;
      const addButton = linkedButton || target.closest('[id^="AddToCart-"], .product-form__cart-submit, button[name="add"], [data-add-to-cart]');
      const addForm = addButton?.form instanceof HTMLFormElement
        ? addButton.form
        : addButton?.closest('form[action*="/cart/add"]');
      if (addButton && addForm && !target.closest(`#${DRAWER_ID}`)) {
        event.preventDefault(); event.stopImmediatePropagation();
        void addFromThemeForm(addForm, addButton);
        return;
      }

      const cartToggle = target.closest('.js-toggle-cart');
      if (cartToggle && !target.closest(`#${DRAWER_ID}`)) {
        event.preventDefault(); event.stopImmediatePropagation();
        void openDrawer(cartToggle);
        return;
      }

      if (target.closest('[data-aic-close],[data-aic-backdrop]')) { closeDrawer(); return; }

      const discountRemove = target.closest('[data-aic-discount-remove]');
      if (discountRemove) {
        event.preventDefault();
        const code = discountRemove.getAttribute('data-aic-discount-remove');
        if (code) void removeDiscountCode(code);
        return;
      }

      if (target.closest('[data-aic-start]')) {
        measureOpenAiCheckoutStarted();
        if (step === 'cart') {
          upsellDecision = null;
          snapshotCartBeforeUpsell();
        }
        const shouldShowUpsell = getUpsellProducts().length > 0 && upsellDecision === null;
        if (shouldShowUpsell) {
          step = 'upsell';
          render();
          queueAicThreadScroll('.aic-upsell-step');
        } else {
          enterDetailsStep();
        }
        return;
      }

      const upsellAdd = target.closest('[data-aic-upsell-add]');
      if (upsellAdd) {
        event.preventDefault();
        void addUpsellToCart(upsellAdd.getAttribute('data-aic-upsell-add'));
        return;
      }

      if (target.closest('[data-aic-upsell-add-selected]')) {
        event.preventDefault();
        void addSelectedUpsellsToCart();
        return;
      }

      if (target.closest('[data-aic-upsell-skip]')) {
        event.preventDefault();
        if (!busy) {
          upsellDecision = 'skipped';
          continueFromUpsell();
        }
        return;
      }

      const payment = target.closest('[data-aic-payment]');
      if (payment) {
        event.preventDefault();
        const preference = payment.getAttribute('data-aic-payment');
        if (preference) void handoffToShopifyCheckout(preference);
        return;
      }

      const change = target.closest('[data-aic-change]');
      if (change) {
        const key = change.getAttribute('data-aic-change');
        const quantity = Number(change.getAttribute('data-aic-quantity'));
        if (key && Number.isInteger(quantity)) void changeLine(key, quantity);
        return;
      }

      const remove = target.closest('[data-aic-remove]');
      if (remove) {
        const key = remove.getAttribute('data-aic-remove');
        if (key) void changeLine(key, 0);
      }
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form?.matches('[data-aic-discount-form]')) return;
      event.preventDefault();
      event.stopPropagation();
      const input = form.querySelector('[data-aic-discount-input]');
      void applyDiscountCode(input?.value || '');
    }, true);

    document.addEventListener('focusout', (event) => {
      const target = event.target instanceof HTMLInputElement ? event.target : null;
      if (!target) return;
      if (target.closest('[data-aic-details-form]') && ['first_name', 'last_name', 'phone', 'email'].includes(target.name)) {
        syncInlinePaymentOptions();
        validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
        return;
      }
      if (target.matches('[data-aic-ship-address]')) {
        if (target.getAttribute('data-aic-ship-address') === 'address1'
          && shippingAddressDraft.cityRecord
          && shippingAddressDraft.address1.trim().length >= 3
          && shippingAddressStatus.state !== 'valid') {
          if (shippingAddressTimer) clearTimeout(shippingAddressTimer);
          shippingAddressTimer = setTimeout(() => { void validateCustomShippingAddress(); }, 120);
        }
      }
    }, true);

    document.addEventListener('input', (event) => {
      const target = event.target instanceof HTMLInputElement ? event.target : null;
      if (!target) return;
      if (target.matches('[data-aic-discount-input]')) {
        discountInputDraft = target.value;
        if (discountFeedback) discountFeedback = null;
        return;
      }
      if (target.matches('[data-aic-ship-search]')) {
        if (shippingOption) shippingSearchDrafts.set(shippingOptionKey(shippingOption), target.value);
        if (shippingSearchTimer) clearTimeout(shippingSearchTimer);
        shippingSearchTimer = setTimeout(() => { void searchCustomPickupPoints(target.value); }, 220);
        return;
      }
      if (target.matches('[data-aic-ship-city-search]')) {
        const value = target.value;
        const selectedName = String(shippingAddressDraft.cityRecord?.name || '');
        shippingAddressDraft.city = value;
        if (!selectedName || value.trim().toLocaleLowerCase('bg-BG') !== selectedName.trim().toLocaleLowerCase('bg-BG')) {
          shippingAddressDraft.cityRecord = null;
          shippingAddressDraft.zip = '';
          shippingAddressDraft.address1 = '';
          shippingSelection = null;
          shippingEditing = true;
          shippingAddressStatus = { state: 'idle', message: '' };
          clearPersistedShippingSelection();
          const zip = document.querySelector('[data-aic-ship-address="zip"]');
          const address = document.querySelector('[data-aic-ship-address="address1"]');
          if (zip instanceof HTMLInputElement) zip.value = '';
          if (address instanceof HTMLInputElement) { address.value = ''; address.disabled = true; }
        }
        if (shippingSearchTimer) clearTimeout(shippingSearchTimer);
        shippingSearchTimer = setTimeout(() => { void searchShippingCities(value); }, 220);
        return;
      }
      if (target.matches('[data-aic-details-form] [name="first_name"], [data-aic-details-form] [name="last_name"], [data-aic-details-form] [name="phone"], [data-aic-details-form] [name="email"]')) {
        customerDraft = {
          firstName: document.querySelector('[data-aic-details-form] [name="first_name"]')?.value.trim() || '',
          lastName: document.querySelector('[data-aic-details-form] [name="last_name"]')?.value.trim() || '',
          phone: document.querySelector('[data-aic-details-form] [name="phone"]')?.value.trim() || '',
          email: document.querySelector('[data-aic-details-form] [name="email"]')?.value.trim() || ''
        };
        if (shippingMethod === 'ADDRESS' && shippingAddressDraft.cityRecord && shippingAddressDraft.address1.trim().length >= 3) {
          shippingSelection = null;
          shippingEditing = true;
          shippingAddressStatus = { state: 'idle', message: '' };
          clearPersistedShippingSelection();
          if (shippingAddressTimer) clearTimeout(shippingAddressTimer);
          shippingAddressTimer = setTimeout(() => { void validateCustomShippingAddress(); }, 650);
          updateAddressStatusDom();
        }
        syncInlinePaymentOptions();
        validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
        return;
      }
      const addressField = target.getAttribute('data-aic-ship-address');
      if (addressField && Object.prototype.hasOwnProperty.call(shippingAddressDraft, addressField)) {
        if (addressField === 'address1') {
          updateShippingAddressDraft(target.value);
          return;
        }
        shippingAddressDraft[addressField] = target.value;
        syncCustomShippingDoneState();
        validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
      }
    }, true);

    document.addEventListener('change', (event) => {
      const target = event.target instanceof HTMLInputElement ? event.target : null;
      if (target?.closest('[data-aic-details-form]') && ['first_name', 'last_name', 'phone', 'email'].includes(target.name)) {
        syncInlinePaymentOptions();
        validateCheckoutRequirements({ showErrors: checkoutValidationErrorsVisible() });
      }
      if (!target || !target.matches('[data-aic-upsell-select]')) return;
      const key = String(target.getAttribute('data-aic-upsell-select') || '');
      if (!key || target.disabled) return;
      if (target.checked) upsellSelectedKeys.add(key);
      else upsellSelectedKeys.delete(key);
      const addSelected = document.querySelector('[data-aic-upsell-add-selected]');
      if (addSelected instanceof HTMLButtonElement) {
        const hasSelection = getUpsellProducts().some((upsell) => !upsell.added && upsellSelectedKeys.has(upsell.key));
        addSelected.disabled = busy || !hasSelection;
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.querySelector('[data-aic-drawer].is-open')) closeDrawer();
    });

    window.addEventListener('pageshow', () => {
      void refreshCart().catch(() => undefined);
      suppressNativeDrawer();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installHooks, { once: true });
  else installHooks();
})();
